// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:07:48.949Z
// Property: Aston Pointe Apartments (ID: 6767906449166310)
// Collections: 24 amenities, 4 floorplans (live), 19 photos, 75 POIs, 2 reviews, 1 virtual tours, 5 office hours, 3 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166310",
  "property_external_id": "4993350",
  "property_zillow_url": "https://www.zillow.com/apartments/aston-pa/aston-pointe/5XkGGC/",
  "property_apartments_url": "https://www.apartments.com/aston-pointe-aston-pa/0k65871/",
  "property_google_business_url": "https://www.google.com/maps/place/Aston+Pointe+Apartment+Homes/data=!4m2!3m1!1s0x0:0xcca2cda50fdfc117?sa=X&ved=2ahUKEwjK75ubjriSAxXImmoFHX-sBa8Q_BJ6BAhKEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "aston-pointe-apartments",
  "property_name": "Aston Pointe Apartments",
  "property_website_url": "https://www.liveastonpointe.com/",
  "property_domain": "https://www.liveastonpointe.com/",
  "property_address": "5001 Pennell Road",
  "property_full_address": "5001 Pennell Rd, Aston Township, PA 19014",
  "property_address_1": "5001 Pennell Rd",
  "property_address_2": null,
  "property_address_city": "Village Green",
  "property_address_state": "PA",
  "property_address_zip_full": "19014-1858",
  "property_address_zip": "19014",
  "property_address_country": "US",
  "property_address_county": "Delaware County",
  "property_neighborhood_address": "Lower Delaware County",
  "property_address_latitude": "39.8653728",
  "property_address_longitude": "-75.4288281",
  "property_email": "astonpointe@aionmanagement.com",
  "property_phone": "(610) 773-6674",
  "property_call_tracking_phone": "888-904-8601",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p>Enjoy our one- and two- bedroom apartment homes for rent in Aston, Pennsylvania.</p>",
  "property_long_description": "<p>Choose from our spacious one and two bedroom floor plans and find your perfect landing place in Delaware County at Aston Pointe Apartments. Our pet-friendly community provides a comfortable retreat with plenty of perks plus friendly neighborhood vibes at an affordable price. Here you can enjoy a park-like setting with scenic landscapes or head to a pub nearby. Situated near major highways and employers, Aston Pointe Apartments offers a lifestyle where work and play are right outside your door.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd911-f89e-70ea-bcd7-5550c11503a2.webp",
  "property_featured_image_media": {
    "alt_text": "Kitchen with black refrigerator, dishwasher, oven, and white cabinets.",
    "public_id": "019fd911-f89e-70ea-bcd7-5550c11503a2",
    "storage_key": "property/6767906449166310/019fd911-f89e-70ea-bcd7-5550c11503a2.webp",
    "width": 1174,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "96",
  "property_year_built": "1965",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Certain dog breeds and mixes (e.g., German Shepherds, Akitas, Chow mixes, American Bulldogs, Staffordshire Terriers, Dobermans, Rottweilers, wolf‑dog hybrids, Pit‑bull terriers, Presa Canario, and Canary dogs) are prohibited.",
  "property_pet_policy_description": "We’re a pet-friendly community and we’re happy to welcome your cats and dogs. You can have up to 2 pets per home. There is a one-time, non-refundable fee of $300 per pet, and monthly pet rent is $50 for the first pet and $25 for the second. Breed Restrictions Apply. Please contact Leasing team for more information.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://astonpointe.loftliving.com/login",
  "property_apply_now_url": "https://www.liveastonpointe.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0267-1372-731e-af12-6e5f9b357f10.webp",
  "property_primary_logo_media": {
    "alt_text": "Aston Pointe Apartments logo",
    "public_id": "019d0267-1372-731e-af12-6e5f9b357f10",
    "storage_key": "property/6767906449166310/019d0267-1372-731e-af12-6e5f9b357f10.webp",
    "width": 300,
    "height": 112
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0267-3275-74ec-adbe-7f34ff90e760.webp",
  "property_secondary_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0267-3275-74ec-adbe-7f34ff90e760",
    "storage_key": "property/6767906449166310/019d0267-3275-74ec-adbe-7f34ff90e760.webp",
    "width": 598,
    "height": 250
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0267-3db8-7129-828a-a5bbfc1014e5.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Aston Pointe Apartments logo",
    "public_id": "019d0267-3db8-7129-828a-a5bbfc1014e5",
    "storage_key": "property/6767906449166310/019d0267-3db8-7129-828a-a5bbfc1014e5.webp",
    "width": 300,
    "height": 112
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0267-478a-762a-b408-a239c240452f.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Aston Pointe Apartments logo.",
    "public_id": "019d0267-478a-762a-b408-a239c240452f",
    "storage_key": "property/6767906449166310/019d0267-478a-762a-b408-a239c240452f.webp",
    "width": 300,
    "height": 112
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "732 - 764",
  "property_sqft_min": "732",
  "property_sqft_max": "764",
  "property_price_range": "1447 - 1879",
  "property_price_min": "1447",
  "property_price_max": "1879",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/astonpointe",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJHza0xzDnxokRF8HfD6XNosw",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_loc=Naamans+Creek+Rd%2C+PA%2C+PA",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Aston Pointe Apartments",
  "property_home_romance_title": "Embrace a New Life in Your Dream Apartment Community",
  "property_home_amenities_blurb": "Welcome to Aston Pointe Apartments in Village Green, PA, where comfort meets convenience. Choose from spacious one- and two-bedroom floor plans, all within a serene, park-like setting. Enjoy our pet-friendly community, featuring a dog park, playground, and easy access to Center City Philadelphia and Downtown Wilmington. Experience home at Aston Pointe!",
  "property_home_floorplans_blurb": "Welcome to Aston Pointe Apartments in Village Green, PA, where modern living meets comfort. Choose from our thoughtfully designed one and two-bedroom floor plans, tailored to fit your lifestyle. Browse our available apartment homes today and unlock the door to your ideal living space!",
  "property_home_gallery_blurb": "Welcome to Aston Pointe Apartments in Village Green, PA, where charm meets convenience. Choose from spacious one and two-bedroom floor plans nestled in a serene, park-like setting. Enjoy top-notch amenities like a dog park, on-site laundry, and easy access to I-95. Picture yourself living here, where comfort thrives!",
  "property_home_neighborhood_blurb": "Nestled in vibrant Village Green, Aston Pointe Apartments offers idyllic one and two-bedroom floor plans, surrounded by a world of adventure. From scenic parks to historic museums and engaging community centers, your new home puts a wealth of activities right at your doorstep, ready to inspire every moment of your day!",
  "property_home_reviews_blurb": "Welcome to Aston Pointe Apartments, where comfort meets convenience! Our residents rave about the exceptional living experience, with one stating, \"A great, quiet place to live. Love love love my apartment and the amenities!\" Situated in Village Green, PA, you'll find yourself close to shops and more. ",
  "property_neighborhood_blurb": "At Aston Pointe Apartments in Village Green, PA, enjoy a vibrant community that embraces both tranquility and adventure. With parks, schools, and recreational facilities nearby, there’s always something to do. From the serene Chester Creek Trail to the engaging Penn Cinema, your ideal lifestyle awaits—immerse yourself in local charm today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Aston Pointe Apartments in Village Green, PA, enjoy a vibrant lifestyle with spacious one and two-bedroom floor plans nestled in a park-like setting. Pet-friendly amenities like a dog park and playground enhance your living experience, while convenient access to Philadelphia and Wilmington awaits. Uncover the comfort today!",
  "property_applynow_blurb": "At Aston Pointe Apartments in Village Green, PA, choose from spacious one- and two-bedroom floor plans tailored to your lifestyle. Enjoy pet-friendly amenities including a playground and dog park, all just 30 minutes from Center City Philadelphia. Experience renovated interiors, convenient online services, and a tranquil, park-like setting. Lease online today!",
  "property_contactus_blurb": "At Aston Pointe Apartments in picturesque Village Green, PA, our thoughtfully designed one- and two-bedroom floor plans provide the perfect blend of comfort and style. Curious about which layout suits your lifestyle? Reach out to our leasing team today for personalized assistance and let us help you find your ideal home!",
  "property_faqs_blurb": "At Aston Pointe Apartments in Village Green, PA, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle needs. Have questions? Our FAQs page offers answers to all your inquiries, ensuring you feel right at home in our vibrant community. Dive into the details today!",
  "property_floorplans_blurb": "At Aston Pointe Apartments in Village Green, PA, our diverse floor plans elevate your living experience. Choose from cozy one-bedroom retreats or spacious two-bedroom havens, designed to suit your lifestyle. Browse our available apartment homes today and envision the perfect backdrop for your next chapter!",
  "property_gallery_blurb": "At Aston Pointe Apartments in Village Green, PA, picture a lifestyle infused with comfort and convenience. Enjoy spacious one and two-bedroom floor plans, pet-friendly amenities, and serene park-like surroundings. With on-site management and modern conveniences, your perfect home awaits—just a short drive from the vibrant life of Philadelphia and Wilmington!",
  "property_interactivemap_blurb": "At Aston Pointe Apartments in Village Green, PA, enjoy spacious one and two-bedroom layouts in a picturesque, park-like setting. Our pet-friendly community features a playground, dog park, and convenient on-site amenities. Use our interactive community map to find your perfect home just 30 minutes from Center City Philadelphia!",
  "property_pets_blurb": "At Aston Pointe Apartments in vibrant Village Green, PA, we celebrate your furry companions! With a welcoming pet policy and beautiful surroundings, your four-legged friends will thrive. Enjoy a community where comfort meets convenience—your pet’s new happy home awaits, complete with lush green spaces for daily adventures!",
  "property_referafriend_blurb": "At Aston Pointe Apartments in Village Green, PA, our spacious one- and two-bedroom floor plans welcome you home. With friendly neighbors and a vibrant community, it’s the ideal setting for shared adventures. Great friends make great neighbors—refer a friend today and build your perfect community!",
  "property_residentaccess_blurb": "Welcome to the Aston Pointe Apartments, where comfort meets convenience in Village Green, PA. Whether you choose a one-bedroom haven or a spacious two-bedroom retreat, our tailored floor plans elevate your living experience. Access your resident portal to manage rent and maintenance requests effortlessly—your lifestyle upgrade is just a click away!",
  "property_reviews_blurb": "At Aston Pointe Apartments in Village Green, PA, residents love the peaceful atmosphere and convenient access to nearby shops. With stunning apartments and amenities, many say, \"I love love love my apartment and the amenities on the property!\" Join our vibrant community and see what our residents have to say!",
  "property_created_at": "1757003829965",
  "property_scheduletour_blurb": "At Aston Pointe Apartments in Village Green, PA, choose from spacious one- and two-bedroom floor plans tailored for your lifestyle. Experience the vibrant community that awaits you—schedule a tour today and see why our residents love calling Aston Pointe home! Your ideal apartment is just a visit away!",
  "property_thankyou_blurb": "Thank you for reaching out to Aston Pointe Apartments in Village Green, PA! Our inviting one and two-bedroom floor plans offer the perfect blend of comfort and style. A team member will be in touch soon to help you find your ideal home—stay tuned for the possibilities that await!",
  "property_virtualtours_blurb": "At Aston Pointe Apartments in Village Green, PA, experience versatile living with our thoughtfully designed one and two-bedroom floor plans. Each space offers modern comforts and style. Ready to envision your new home? Take a virtual tour of our community and apartments for rent today!",
  "property_copyright": "2025 All Rights Reserved. Aston Pointe Apartments",
  "property_seo_title_home": "Aston Pointe Apartments |  Apartments in Village Green, PA",
  "property_seo_description_home": "Embrace comfort at Aston Pointe Apartments in Village Green, PA. Enjoy pet-friendly living, spacious layouts, and easy access to I-95. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Village Green, PA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at Aston Pointe Apartments in Village Green, PA! Browse unique one and two-bedroom floor plans tailored just for you.",
  "property_seo_title_amenities": "Amenities | Village Green, PA Apartments for Rent",
  "property_seo_description_amenities": "Discover Aston Pointe Apartments in Village Green, PA! Enjoy pet-friendly living, spacious floor plans, and easy access to Philly and Wilmington.",
  "property_seo_title_gallery": "Gallery | Apartments in Village Green, PA",
  "property_seo_description_gallery": "Discover Aston Pointe Apartments in Village Green, PA: spacious one and two-bedroom homes, pet-friendly perks, and a scenic park-like setting!",
  "property_seo_title_virtualtours": "Virtual Tours | Aston Pointe Apartments Apartments",
  "property_seo_description_virtualtours": "Step into your dream home at Aston Pointe Apartments in Village Green, PA. Experience our inviting one- and two-bedroom floor plans—take a virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Aston Pointe Apartments Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Aston Pointe Apartments in Village Green, PA. Enjoy spacious floor plans, pet-friendly amenities, and flexible lease options.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Village Green, PA",
  "property_seo_description_neighborhood": "Uncover the vibrant charm of Village Green, PA, around Aston Pointe Apartments. Dive into local favorites and explore nearby gems that enrich your lifestyle!",
  "property_seo_title_contact": "Contact Us | Aston Pointe Apartments",
  "property_seo_description_contact": "Experience the comfort of Aston Pointe Apartments in Village Green, PA. From cozy one-beds to spacious two-beds, our leasing team is ready to assist you!",
  "property_seo_title_faqs": "FAQs | Apartments in Village Green, PA",
  "property_seo_description_faqs": "Find answers to your questions about Aston Pointe Apartments in Village Green, PA. Learn about our amenities, pet policies, and more—your new home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Village Green, PA",
  "property_seo_description_reviews": "Join the Aston Pointe community in Village Green, PA! Pet-friendly living, spacious apartments, and rave reviews await. See what our residents love today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Village Green, PA",
  "property_seo_description_applynow": "Find your perfect home at Aston Pointe Apartments in Village Green, PA. Enjoy spacious floor plans, pet-friendly amenities, and easy city access—apply today!",
  "property_seo_title_residentaccess": "Resident Access | Aston Pointe Apartments",
  "property_seo_description_residentaccess": "Unlock convenience at Aston Pointe Apartments! Log in to access your resident portal for seamless rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Aston Pointe Apartments",
  "property_seo_description_referafriend": "Refer a friend to Aston Pointe Apartments in Village Green, PA! Great friends make great neighbors—help someone find their perfect home today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Aston Pointe Apartments",
  "property_seo_description_scheduletour": "Experience stylish living at Aston Pointe Apartments in Village Green, PA. Schedule a tour today and envision your new home in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Aston Pointe Apartments",
  "property_seo_description_privacy": "At Aston Pointe Apartments in Village Green, PA, your privacy matters. Delve into our commitment to protecting your information. View our privacy policy now!",
  "property_seo_title_accessibility": "Website Accessibility | Aston Pointe Apartments",
  "property_seo_description_accessibility": "Enhance your living experience at Aston Pointe Apartments in Village Green, PA. We prioritize accessibility for all—because everyone deserves to feel at home.",
  "property_seo_title_sitemap": "Sitemap | Aston Pointe Apartments",
  "property_seo_description_sitemap": "Navigate your future at Aston Pointe Apartments in Village Green, PA. Access our sitemap for a seamless journey through your next home and community amenities!",
  "property_seo_title_thankyou": "Thank You | Aston Pointe Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Aston Pointe Apartments in Village Green! A team member will connect with you soon to discuss your future home. Stay tuned!",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1791293670288",
  "amenities": [
    {
      "id": "custom_d8f17dea-cf45-426a-b497-d97b88193fb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_02032160-ccea-44ef-9d66-8da2e398f121",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cc01538a-e0a1-47b6-9f41-b1943149e1cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rental Payment & Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d6068d6f-9cb4-4848-9d0c-ca5e0a596e80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9d6c5859-d495-469a-8091-a75c99bd0fed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7266faf2-f570-493f-ab4a-4a6880ceaf0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "Professional On-Site Management Team",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_33e3b630-8c75-4a1e-a5ea-426c653be1bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "Short-Term Leases",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fecd3ffa-4397-40dc-9da8-a751275e5eb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6000a40a-11c6-410c-9b5a-567946f98ac3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_934b5f17-23af-4782-8412-d2c38c14da08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c20c87a7-0655-4605-90d0-9b2a1cee4f7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "Fully Equipped Kitchen",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_25c2db69-7482-4d0b-a122-0eab0a6672a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "Hardwood Flooring & Carpeting",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_139b9d91-5c66-46af-ad1a-a7dd7aded0b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "High-Speed Internet Access*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_df3a5543-015a-4bb1-8702-d7f2f00c0fe7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2660d7e3-38e6-4c1e-a745-458b0d2a93e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1b8dfadd-8828-4874-a826-44af7d2716f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Bathrooms Available*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_65d44395-095d-48b1-98b7-35f3fcff64f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Kitchens Available*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5130201c-db99-4e63-806c-c7eac16bdb69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "Minutes to I-95 and I-476",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9b15c00e-54b6-4048-9952-be7c2d5e8656",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "Park-Like Setting with Mature Landscaping",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ae5d931c-da0a-4890-aa72-d5a9e137b22d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "20 Minutes to Downtown Wilmington",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ecd094ee-b1cf-469f-8235-93c0a4b74ded",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "30 Minutes to Center City Philadelphia",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a1f5b74d-351e-4e04-b08f-8ba4584b58de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_88c9feba-a3ad-42e9-84cf-b6d88970779a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "Off-Street Parking",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_09c8058e-4767-42a4-b50c-cf31af3ddbe9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_4ac14e66-f379-447c-b168-c927ec101526",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-a85a-772c-be16-37d75d07ebf9.webp",
      "image_media": {
        "alt_text": "Modern living room with dark gray sofa, accent chairs, coffee table, and abstract art.",
        "public_id": "019fd91d-a85a-772c-be16-37d75d07ebf9",
        "storage_key": "property/6767906449166310/019fd91d-a85a-772c-be16-37d75d07ebf9.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Cozy living room with gray couch and modern decor",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/35e75ac3/dms3rep/multi/opt/5767906449162442/6767906449166310/2b0ae5d519c29596c01e028c4e96774a-1920w.webp"
    },
    {
      "id": "custom_33cf880d-c3c9-4635-a0f2-a4f01e3006a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-a859-721f-8369-f91382bad0a2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances and white cabinets",
        "public_id": "019fd91d-a859-721f-8369-f91382bad0a2",
        "storage_key": "property/6767906449166310/019fd91d-a859-721f-8369-f91382bad0a2.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Modern kitchen with black appliances and white cabinets",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/35e75ac3/dms3rep/multi/opt/5767906449162442/6767906449166310/1c0cd4a26f937d7f0e4d42f6a4e13679-1920w.webp"
    },
    {
      "id": "custom_115e7b30-8ca1-4d98-bdcb-f55bba1a71d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-a8ad-7119-aa3b-c781f7645f17.webp",
      "image_media": {
        "alt_text": "Clean white kitchen with appliances and wood floor.",
        "public_id": "019fd91d-a8ad-7119-aa3b-c781f7645f17",
        "storage_key": "property/6767906449166310/019fd91d-a8ad-7119-aa3b-c781f7645f17.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Apartment",
      "description": "Explore this stylish apartment kitchen featuring stainless steel appliances, modern white cabinetry, and ample counter space, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets and appliances",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/35e75ac3/dms3rep/multi/opt/5767906449162442/6767906449166310/11bfd7eb5a51e988939aa8a0562f453e-1920w.webp"
    },
    {
      "id": "custom_0fa162e7-0642-43bf-b24b-7cfda1d5bb95",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-a8d3-71df-9993-214bb6362d10.webp",
      "image_media": {
        "alt_text": "Spacious living room with a sectional sofa and a coffee table, leading to an open kitchen area.",
        "public_id": "019fd91d-a8d3-71df-9993-214bb6362d10",
        "storage_key": "property/6767906449166310/019fd91d-a8d3-71df-9993-214bb6362d10.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully appointed apartment featuring a spacious living room, stylish furniture, and a modern, open-concept kitchen.",
      "link": "false",
      "alt_text": "Modern living room with light gray walls, a large sofa, and a coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/35e75ac3/dms3rep/multi/opt/5767906449162442/6767906449166310/45459504c61a99db5c242044fd1bfdd1-1920w.webp"
    },
    {
      "id": "custom_6bfa736e-51a3-4028-ae28-941c36d378d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-b2e2-770b-8ff4-5f165a80c07e.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, large TV, and a window overlooking the neighborhood.",
        "public_id": "019fd91d-b2e2-770b-8ff4-5f165a80c07e",
        "storage_key": "property/6767906449166310/019fd91d-b2e2-770b-8ff4-5f165a80c07e.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Apartment",
      "description": "Explore this cozy living room featuring modern decor, natural light, and a spacious layout, perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Bright living room with couch, plant, and TV unit",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/35e75ac3/dms3rep/multi/opt/5767906449162442/6767906449166310/c5388c84e0374d03a3be08a5c0e45006-1920w.webp"
    },
    {
      "id": "custom_4a08ffeb-3865-471e-97ec-f2797c2db282",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-b3c9-74ac-8394-a6d5507d009b.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, TV, and doorway to kitchen.",
        "public_id": "019fd91d-b3c9-74ac-8394-a6d5507d009b",
        "storage_key": "property/6767906449166310/019fd91d-b3c9-74ac-8394-a6d5507d009b.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Apartment",
      "description": "Explore this spacious and beautifully designed apartment featuring a stylish living area, complete with modern furnishings and an open layout that connects to the kitchen.",
      "link": "false",
      "alt_text": "Modern living room with a couch, television, and kitchen in background",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/35e75ac3/dms3rep/multi/opt/5767906449162442/6767906449166310/5b6b64b0aa62089c1357ee38059d3685-1920w.webp"
    },
    {
      "id": "custom_da1de87e-080e-4ef6-8923-afdf68377bde",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-b3f0-717d-9a8b-9a8f689d9bdc.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a large bed, stacked washer and dryer.",
        "public_id": "019fd91d-b3f0-717d-9a8b-9a8f689d9bdc",
        "storage_key": "property/6767906449166310/019fd91d-b3f0-717d-9a8b-9a8f689d9bdc.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Cozy bedroom featuring a bed and stacked washer-dryer unit",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/35e75ac3/dms3rep/multi/opt/5767906449162442/6767906449166310/24ac7c18209a05acd438b9a12377429b-1920w.webp"
    },
    {
      "id": "custom_2a930c1f-1a69-4e2f-aa26-34e756ebaf72",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-b633-709c-8f92-670b460afa3c.webp",
      "image_media": {
        "alt_text": "A bright and airy bedroom with a queen-size bed, bedside table, and closet.",
        "public_id": "019fd91d-b633-709c-8f92-670b460afa3c",
        "storage_key": "property/6767906449166310/019fd91d-b633-709c-8f92-670b460afa3c.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Apartment",
      "description": "Explore this beautifully designed bedroom showcasing modern furnishings, ample natural light, and spacious closet options.",
      "link": "false",
      "alt_text": "A well-decorated bedroom with a bed, nightstand, and closet space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/35e75ac3/dms3rep/multi/opt/5767906449162442/6767906449166310/bca711519ecd58c634781ac5e358545d-1920w.webp"
    },
    {
      "id": "custom_8841a124-ffe1-4de6-b446-cd0bb04ecef5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-bd29-758e-be2a-f868e0a14214.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances and white cabinets.",
        "public_id": "019fd91d-bd29-758e-be2a-f868e0a14214",
        "storage_key": "property/6767906449166310/019fd91d-bd29-758e-be2a-f868e0a14214.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Apartment",
      "description": "Stylish apartment kitchen featuring modern black appliances, sleek white cabinetry, and a polished countertop, ideal for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with black appliances and white cabinets",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/35e75ac3/dms3rep/multi/opt/5767906449162442/6767906449166310/a898dacd65c159434ce291dcf0d8d562-1920w.webp"
    },
    {
      "id": "custom_6c809276-44af-4acc-a56d-e64ec5bdf23e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-bd6a-732a-ae67-586093546f57.webp",
      "image_media": {
        "alt_text": "Fully furnished bedroom with a large bed, dresser, and bedside tables.",
        "public_id": "019fd91d-bd6a-732a-ae67-586093546f57",
        "storage_key": "property/6767906449166310/019fd91d-bd6a-732a-ae67-586093546f57.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Apartment",
      "description": "Explore this beautifully designed apartment bedroom, featuring a modern touch with stylish decor and a comfortable layout. Perfect for relaxation and restful nights.",
      "link": "false",
      "alt_text": "A cozy bedroom featuring a bed with grey bedding and decorative pillows, a dresser, and artwork on the walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/35e75ac3/dms3rep/multi/opt/5767906449162442/6767906449166310/ca881013e4e3188ff6114fc00cbc365d-1920w.jpg"
    },
    {
      "id": "custom_baab9728-0d9b-4295-8fb6-cbc0404158c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-be04-765b-aa11-4be3e4b6fa31.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, dresser, desk, and closet doors.",
        "public_id": "019fd91d-be04-765b-aa11-4be3e4b6fa31",
        "storage_key": "property/6767906449166310/019fd91d-be04-765b-aa11-4be3e4b6fa31.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Apartment",
      "description": "Spacious bedroom with modern decor and ample storage, perfect for relaxation and productivity.",
      "link": "false",
      "alt_text": "A bedroom featuring a bed with decorative pillows, a bedside lamp, a dresser, and a desk with a chair against a light,ed",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/35e75ac3/dms3rep/multi/opt/5767906449162442/6767906449166310/78253056ff645f02c687e5ba0ace19b5-1920w.jpg"
    },
    {
      "id": "custom_0dc93c65-02f8-4297-89e5-5ad1cf785d86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-c0a0-720b-b9e1-163ae65f13cf.webp",
      "image_media": {
        "alt_text": "Apartment buildings with manicured lawns and mature trees.",
        "public_id": "019fd91d-c0a0-720b-b9e1-163ae65f13cf",
        "storage_key": "property/6767906449166310/019fd91d-c0a0-720b-b9e1-163ae65f13cf.webp",
        "width": 1920,
        "height": 1277
      },
      "title": "Community",
      "description": "Welcome to our vibrant community featuring beautiful green spaces and inviting residential buildings. Enjoy the serene atmosphere and ample outdoor space designed for relaxation and recreation.",
      "link": "false",
      "alt_text": "A grassy area with trees and residential building in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/35e75ac3/dms3rep/multi/opt/5767906449162442/6767906449166310/4dd2fbbe9c3fcefc499edba293608772-1920w.webp"
    },
    {
      "id": "custom_2cf2a90e-babf-4024-9f53-2dba5e8e1c4d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-c7b3-7158-8367-cbd8a84897e0.webp",
      "image_media": {
        "alt_text": "Covered picnic area with picnic tables, grill, and playground in the background.",
        "public_id": "019fd91d-c7b3-7158-8367-cbd8a84897e0",
        "storage_key": "property/6767906449166310/019fd91d-c7b3-7158-8367-cbd8a84897e0.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Community",
      "description": "Enjoy gatherings at our community's spacious covered picnic area, equipped with tables and a grill, perfect for family and friends. Nearby, children's playground adds fun for all ages.",
      "link": "false",
      "alt_text": "Covered picnic area with tables and playground in the background",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/35e75ac3/dms3rep/multi/opt/5767906449162442/6767906449166310/3337da8006021dfcefd977e60736e0d0-1920w.webp"
    },
    {
      "id": "custom_08c3424c-b045-42aa-9aee-b3abeea0e0b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-c7f5-756e-ab48-57360b33ca06.webp",
      "image_media": {
        "alt_text": "Playground with slides and swings",
        "public_id": "019fd91d-c7f5-756e-ab48-57360b33ca06",
        "storage_key": "property/6767906449166310/019fd91d-c7f5-756e-ab48-57360b33ca06.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Colorful playground with a slide and climbing structures",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/35e75ac3/dms3rep/multi/opt/5767906449162442/6767906449166310/4ceae067235fbbe4654e01aa81ea6f8d-1920w.webp"
    },
    {
      "id": "custom_53c65c11-b881-4203-96ae-64ab3b7a33c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-c894-77da-889a-706febf384ca.webp",
      "image_media": {
        "alt_text": "Community dog park with agility equipment and fire hydrants.",
        "public_id": "019fd91d-c894-77da-889a-706febf384ca",
        "storage_key": "property/6767906449166310/019fd91d-c894-77da-889a-706febf384ca.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Community",
      "description": "Explore our serene community space, featuring a playground, dog park, and open grassy areas perfect for relaxation and play.",
      "link": "false",
      "alt_text": "Open green space with play equipment and a park bench",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/35e75ac3/dms3rep/multi/opt/5767906449162442/6767906449166310/ccd65f9e2e6d6d1da4098395b84b3d40-1920w.jpg"
    },
    {
      "id": "custom_af7bc580-0961-421a-9dce-a2e799ca72c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-cba5-728e-8073-8710e9584a40.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment building with a manicured lawn and large trees.",
        "public_id": "019fd91d-cba5-728e-8073-8710e9584a40",
        "storage_key": "property/6767906449166310/019fd91d-cba5-728e-8073-8710e9584a40.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Exterior view of a brick apartment building with green lawn and trees",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/35e75ac3/dms3rep/multi/opt/5767906449162442/6767906449166310/40534e5d2f4150cebcd6bbeda86fcc62-1920w.webp"
    },
    {
      "id": "custom_300e8054-94ac-461b-876c-608f3fdbc96c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-d2b1-72d7-9753-6bc6cde86077.webp",
      "image_media": {
        "alt_text": "Brick apartment buildings with white trim and green lawns.",
        "public_id": "019fd91d-d2b1-72d7-9753-6bc6cde86077",
        "storage_key": "property/6767906449166310/019fd91d-d2b1-72d7-9753-6bc6cde86077.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Exterior view of a two-story brick apartment building with a well-maintained entrance and landscape.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/35e75ac3/dms3rep/multi/opt/5767906449162442/6767906449166310/4c14056a3be772372a4c62f7509062a1-1920w.jpg"
    },
    {
      "id": "custom_7fabd371-5933-4444-8381-1104cc5bc888",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-d32c-7299-b3d1-2f9f167dddb8.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with red brick and white shutters.",
        "public_id": "019fd91d-d32c-7299-b3d1-2f9f167dddb8",
        "storage_key": "property/6767906449166310/019fd91d-d32c-7299-b3d1-2f9f167dddb8.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Community",
      "description": "Charming exterior view showcasing the red brick apartment buildings with neatly manicured lawns and welcoming entrances.",
      "link": "false",
      "alt_text": "Exterior view of a residential building with landscaping and pathway",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/35e75ac3/dms3rep/multi/opt/5767906449162442/6767906449166310/e322beba24eced3e0c40114e5ed741d1-1920w.webp"
    },
    {
      "id": "custom_a2931cb4-fbe5-40ec-9d30-6299f99a65dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019fd91d-d3d1-744b-837f-3176c63d4797.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by trees and residential housing.",
        "public_id": "019fd91d-d3d1-744b-837f-3176c63d4797",
        "storage_key": "property/6767906449166310/019fd91d-d3d1-744b-837f-3176c63d4797.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Explore our vibrant community from above, showcasing the lush greenery and beautifully arranged homes that make this a perfect place to live. Ideal for families and individuals alike, our community is",
      "link": "false",
      "alt_text": "Aerial view of a residential community with houses and green spaces.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/35e75ac3/dms3rep/multi/opt/5767906449162442/6767906449166310/e65df38dd60b698cebb923e15c0ac514-1920w.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_adec6590-3f86-4789-ba70-3ff9f5f49bd9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "The tattooed pig",
      "poi_type": "Restaurants",
      "poi_address": "4405 Pennell Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-87cd-707a-8757-056b85df851d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-87cd-707a-8757-056b85df851d",
        "storage_key": "property/6767906449166310/019d0265-87cd-707a-8757-056b85df851d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://tattooedpigmedia.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16226921626812497534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-tattooed-pig",
      "poi_latitude": "39.8561847",
      "poi_longitude": "-75.4277254",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 484-490-5521",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1583-74d8-b465-01ef28e40071",
        "storage_key": "property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPWQ0r2TnxokRfj5D5D6bMeE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_3844d307-5430-48e2-a414-a0c426ea6f1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Taste Budz Cafe",
      "poi_type": "Restaurants",
      "poi_address": "4820 Pennell Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "Casual eatery serving breakfast dishes such as omelets and pancakes plus dinner.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-8830-7319-a3d7-95b797ae5dcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-8830-7319-a3d7-95b797ae5dcc",
        "storage_key": "property/6767906449166310/019d0265-8830-7319-a3d7-95b797ae5dcc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tastebudzaston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6539591953361017334&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taste-budz-cafe",
      "poi_latitude": "39.8614888",
      "poi_longitude": "-75.4267931",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 610-494-8062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1583-74d8-b465-01ef28e40071",
        "storage_key": "property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWR6sc6zoxokR9hkWvDtMwVo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_231faaa1-8644-46f1-bf47-7d6df081044f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Aston Diner",
      "poi_type": "Restaurants",
      "poi_address": "3601 Concord Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "All-hours diner offering traditional American grub, including breakfast, in an easygoing atmosphere.",
      "poi_long_description": "All-hours diner offering traditional American grub, including breakfast, in an easygoing atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-879e-7659-8449-b8c3e6002b60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-879e-7659-8449-b8c3e6002b60",
        "storage_key": "property/6767906449166310/019d0265-879e-7659-8449-b8c3e6002b60.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.astondiner.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13589078573198093695&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aston-diner",
      "poi_latitude": "39.869053",
      "poi_longitude": "-75.4294583",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 610-494-5656",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1583-74d8-b465-01ef28e40071",
        "storage_key": "property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMyDTZQHmxokRfy1Y3PYalrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_09417d57-ddc1-43aa-97f9-95807e8afbc3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Gennaro's Italian Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "4600 Pennell Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "Low-key locale serving familiar Italian dishes such as veal marsala & pasta with a choice of sauce.",
      "poi_long_description": "Low-key locale serving familiar Italian dishes such as veal marsala & pasta with a choice of sauce.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-89a8-7697-aaed-826fd9addd99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-89a8-7697-aaed-826fd9addd99",
        "storage_key": "property/6767906449166310/019d0265-89a8-7697-aaed-826fd9addd99.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.gennarosaston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9074743737164513621&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gennaros-italian-kitchen",
      "poi_latitude": "39.8581593",
      "poi_longitude": "-75.42674509999999",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 610-497-3393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1583-74d8-b465-01ef28e40071",
        "storage_key": "property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJafmi0gXmxokRVUFkUVn3730",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_fa019686-c475-4853-90e4-368464631242",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Applebee's Grill + Bar",
      "poi_type": "Restaurants",
      "poi_address": "4301 Pennell Rd, Aston, PA 19014, USA",
      "poi_short_description": "Full-service chain bar & grill providing hearty American eats in an informal setting.",
      "poi_long_description": "Full-service chain bar & grill providing hearty American eats in an informal setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-9041-7640-a06c-dc2d608c025d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-9041-7640-a06c-dc2d608c025d",
        "storage_key": "property/6767906449166310/019d0265-9041-7640-a06c-dc2d608c025d.webp",
        "width": 1018,
        "height": 1280
      },
      "poi_business_url": "https://restaurants.applebees.com/en-us/pa/aston/4301-pennell-road-76022?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=76022&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=14967974171719659731&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "applebees-grill--bar",
      "poi_latitude": "39.8542102",
      "poi_longitude": "-75.4272989",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-485-3528",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1583-74d8-b465-01ef28e40071",
        "storage_key": "property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz7Y66A7mxokR03CSmDTtuM8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d42e56f7-b04d-4aaf-8346-262a02a4b998",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Barnaby's Restaurant & Pub",
      "poi_type": "Restaurants",
      "poi_address": "5501 Pennell Rd, Media, PA 19063, USA",
      "poi_short_description": "Pub & grill offering craft beers, burgers & sandwiches in a laid-back space with patio seating.",
      "poi_long_description": "Pub & grill offering craft beers, burgers & sandwiches in a laid-back space with patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-9311-726a-9bfe-a32015ab4c06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-9311-726a-9bfe-a32015ab4c06",
        "storage_key": "property/6767906449166310/019d0265-9311-726a-9bfe-a32015ab4c06.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.barnabysrestaurantandpub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13887791333119600891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barnabys-restaurant--pub",
      "poi_latitude": "39.8839035",
      "poi_longitude": "-75.43088809999999",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-558-1929",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1582-770f-8623-9ba793756407.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1582-770f-8623-9ba793756407",
        "storage_key": "property/6767906449166310/019d0266-1582-770f-8623-9ba793756407.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAZwi3gPmxokR-6hXBaNYu8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_cd979fe9-5623-4d24-96a7-e8fe43033f53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Phoenix Bar & Grill Aston",
      "poi_type": "Restaurants",
      "poi_address": "4936 Pennell Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-900e-73a9-950b-ac67eb1d344b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-900e-73a9-950b-ac67eb1d344b",
        "storage_key": "property/6767906449166310/019d0265-900e-73a9-950b-ac67eb1d344b.webp",
        "width": 1280,
        "height": 665
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15975160366734006654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phoenix-bar--grill-aston",
      "poi_latitude": "39.8631991",
      "poi_longitude": "-75.42658620000002",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 610-494-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1583-74d8-b465-01ef28e40071",
        "storage_key": "property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxY7Xdm_nxokRflkUqbYrs90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a3f73dfe-004d-4e6c-b957-0e3947688ad1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Big Bad Wolf Barbeque BBQ",
      "poi_type": "Restaurants",
      "poi_address": "4916 Pennell Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "Baked beans, brisket, ribs, and other wood-smoked BBQ dishes dished up in casual environs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-92c0-75ce-a6c7-a46b52d05a58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-92c0-75ce-a6c7-a46b52d05a58",
        "storage_key": "property/6767906449166310/019d0265-92c0-75ce-a6c7-a46b52d05a58.webp",
        "width": 1252,
        "height": 1280
      },
      "poi_business_url": "http://www.toasttab.com/big-bad-wolf-barbeque-bbq",
      "poi_directions_map_url": "https://maps.google.com/?cid=2509326567606509270&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-bad-wolf-barbeque-bbq",
      "poi_latitude": "39.8627797",
      "poi_longitude": "-75.4265928",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 484-480-4676",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1583-74d8-b465-01ef28e40071",
        "storage_key": "property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVx8yjwXmxokR1t6i3zfr0iI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_b2298c5e-0c57-4a1e-8003-874db1418ddc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Cocco's Pizza Aston",
      "poi_type": "Restaurants",
      "poi_address": "2430 Dutton Mill Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "Long-running local pizzeria chain serving hand-tossed red & white pies, sandwiches & wings.",
      "poi_long_description": "Long-running local pizzeria chain serving hand-tossed red & white pies, sandwiches & wings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-9b77-7599-8581-bf6146a31e06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-9b77-7599-8581-bf6146a31e06",
        "storage_key": "property/6767906449166310/019d0265-9b77-7599-8581-bf6146a31e06.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.coccosaston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9869437888417630333&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coccos-pizza-aston",
      "poi_latitude": "39.8638574",
      "poi_longitude": "-75.4170164",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-494-4797",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1583-74d8-b465-01ef28e40071",
        "storage_key": "property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1e_IfxnmxokRfQjqD3hJ94g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_3e9fa0b3-9594-4bf8-9070-2d1a2f88392e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Tom's Pizza Place",
      "poi_type": "Restaurants",
      "poi_address": "3223 Concord Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "Casual venue serving pizza, wings, and other comfort food, with late-night hours.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-9d46-713a-ab7d-03a62a2e590c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-9d46-713a-ab7d-03a62a2e590c",
        "storage_key": "property/6767906449166310/019d0265-9d46-713a-ab7d-03a62a2e590c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13679204294768154952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toms-pizza-place",
      "poi_latitude": "39.86495559999999",
      "poi_longitude": "-75.41846389999999",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-497-5775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1583-74d8-b465-01ef28e40071",
        "storage_key": "property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlXsHcgHmxokRSFmnn9RL1r0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_b9773355-9826-4bc7-af3a-a12ee3bd1c26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "PrimoHoagies",
      "poi_type": "Restaurants",
      "poi_address": "3474 Concord Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "Philly-born counter-serve sandwich chain known for its hefty hoagies built on sesame-seed rolls.",
      "poi_long_description": "Philly-born counter-serve sandwich chain known for its hefty hoagies built on sesame-seed rolls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-9d46-713a-ab7c-f93c48d8c364.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-9d46-713a-ab7c-f93c48d8c364",
        "storage_key": "property/6767906449166310/019d0265-9d46-713a-ab7c-f93c48d8c364.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://www.primohoagies.com/location/Aston-PA",
      "poi_directions_map_url": "https://maps.google.com/?cid=14252684779891176251&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primohoagies",
      "poi_latitude": "39.868639",
      "poi_longitude": "-75.42671399999999",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 610-497-1611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1583-74d8-b465-01ef28e40071",
        "storage_key": "property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlXsHcgHmxokRO7MHGUu1y8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_6809b445-6255-4fe7-bc7d-ff140b02b03c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Pappone's Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "2901 Concord Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "Pizzeria offering pies, hoagies, and steak sandwiches in a casual atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-9e55-7638-b1d1-f9ccff7c7d80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-9e55-7638-b1d1-f9ccff7c7d80",
        "storage_key": "property/6767906449166310/019d0265-9e55-7638-b1d1-f9ccff7c7d80.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://papponespizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5191026028804292881&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pappones-pizzeria",
      "poi_latitude": "39.8612975",
      "poi_longitude": "-75.413454",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 610-492-1090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1583-74d8-b465-01ef28e40071",
        "storage_key": "property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS4Wj2QLnxokREcGvgqs6Ckg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_d7a12a37-a1b8-4979-a828-f8166249787d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Josephine's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "811 Aston Mills Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3709215877300037567&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "josephines-pizza",
      "poi_latitude": "39.8754359",
      "poi_longitude": "-75.4501538",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 610-459-9660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1583-74d8-b465-01ef28e40071",
        "storage_key": "property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD4OEnljvxokRvye1KTDIeTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_23334d6a-220e-4769-9c08-6165fd5536c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "5020 Pennell Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-a537-70da-8b85-da7707756289.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-a537-70da-8b85-da7707756289",
        "storage_key": "property/6767906449166310/019d0265-a537-70da-8b85-da7707756289.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/aston-pa-pharmacies/5020-pennell-rd-aston-pa-19014/storeid=828?WT.mc_id=LS_GOOGLE_RX_828",
      "poi_directions_map_url": "https://maps.google.com/?cid=3405887384845691066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "39.8665517",
      "poi_longitude": "-75.4273281",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 610-497-2225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1587-7559-af0f-479ec08e589d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1587-7559-af0f-479ec08e589d",
        "storage_key": "property/6767906449166310/019d0266-1587-7559-af0f-479ec08e589d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW_26FATmxokRuii2BogkRC8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_e26d3d74-6245-484e-81f2-f0b751015e9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Wawa",
      "poi_type": "Shopping & Retail",
      "poi_address": "5008 Pennell Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_long_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-a313-7329-88d7-8e6f176ecc91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-a313-7329-88d7-8e6f176ecc91",
        "storage_key": "property/6767906449166310/019d0265-a313-7329-88d7-8e6f176ecc91.webp",
        "width": 500,
        "height": 400
      },
      "poi_business_url": "https://www.wawa.com/locations/8027?utm_source=gmblisting&utm_medium=organic&utm_campaign=locallisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=87613731589758542&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wawa",
      "poi_latitude": "39.8653389",
      "poi_longitude": "-75.4272799",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 610-494-4051",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1583-74d8-b465-01ef28e40071",
        "storage_key": "property/6767906449166310/019d0266-1583-74d8-b465-01ef28e40071.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcwuyNwTmxokRTp7ahDlENwE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_a0fc92ab-d39f-40b9-aace-b9beaf04f66f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "GIANT",
      "poi_type": "Shopping & Retail",
      "poi_address": "3400 Concord Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "Grocery chain offering everyday items, plus premium beer and wine selections, and fresh sushi.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-a319-701a-94a7-0040400c0741.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-a319-701a-94a7-0040400c0741",
        "storage_key": "property/6767906449166310/019d0265-a319-701a-94a7-0040400c0741.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.giantfoodstores.com/pa/aston/3400-concord-road?y_source=1_NDE5NTYwNS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13833619936411364444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "giant",
      "poi_latitude": "39.867484",
      "poi_longitude": "-75.42389589999999",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 610-497-5375",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1585-7469-b4f5-ca5433fcdaa7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1585-7469-b4f5-ca5433fcdaa7",
        "storage_key": "property/6767906449166310/019d0266-1585-7469-b4f5-ca5433fcdaa7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL4-5WwPmxokRXKyP2wnk-r8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5a89f587-68f9-4625-85d6-3e75fce473f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "3620 Concord Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-ab6c-727e-8ba6-4a8eb58beb94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-ab6c-727e-8ba6-4a8eb58beb94",
        "storage_key": "property/6767906449166310/019d0265-ab6c-727e-8ba6-4a8eb58beb94.webp",
        "width": 1280,
        "height": 1043
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3620+concord+rd-aston-pa-19014/id=4487",
      "poi_directions_map_url": "https://maps.google.com/?cid=947240839811327742&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "39.87015969999999",
      "poi_longitude": "-75.429322",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 610-485-8102",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-19f2-718d-b2a0-91954f5ebbc5",
        "storage_key": "property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlXsHcgHmxokR_maybYZGJQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_cbf0b4db-39ea-4a51-9660-95a9d02f3586",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "ShopRite of Brookhaven",
      "poi_type": "Shopping & Retail",
      "poi_address": "5075 Edgmont Ave, Brookhaven, PA 19015, USA",
      "poi_short_description": "Supermarket chain with brand-name & house-label groceries, plus a bakery & a deli.",
      "poi_long_description": "Supermarket chain with brand-name & house-label groceries, plus a bakery & a deli.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-a9d7-73da-bd97-b88bc839aa6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-a9d7-73da-bd97-b88bc839aa6b",
        "storage_key": "property/6767906449166310/019d0265-a9d7-73da-bd97-b88bc839aa6b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.shoprite.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8704076178514409596&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shoprite-of-brookhaven",
      "poi_latitude": "39.8797544",
      "poi_longitude": "-75.3960147",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-499-3030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1585-7469-b4f5-ca5433fcdaa7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1585-7469-b4f5-ca5433fcdaa7",
        "storage_key": "property/6767906449166310/019d0266-1585-7469-b4f5-ca5433fcdaa7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR-RlDI_oxokRfHhKDisXy3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0a644a3c-aa91-4486-b2ed-1fb369cdf666",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "3464 Concord Rd Village Green, Shp Ctr, Aston, PA 19014, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-aa3c-77bb-8467-adb729a8a96a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-aa3c-77bb-8467-adb729a8a96a",
        "storage_key": "property/6767906449166310/019d0265-aa3c-77bb-8467-adb729a8a96a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.familydollar.com/pa/aston/3464-concord-rd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5042312531778407247&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "39.8682637",
      "poi_longitude": "-75.4257707",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 484-842-9917",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1a0d-7058-a1d7-1d0607eaf6a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1a0d-7058-a1d7-1d0607eaf6a9",
        "storage_key": "property/6767906449166310/019d0266-1a0d-7058-a1d7-1d0607eaf6a9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJlXsHcgHmxokRTwsnR4jk-UU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_bc0a7266-1d21-4ad9-ac52-7cb2a49dfbd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "5110 Pennell Rd, Media, PA 19063, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-ae61-7762-a69a-63068fb9c096.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-ae61-7762-a69a-63068fb9c096",
        "storage_key": "property/6767906449166310/019d0265-ae61-7762-a69a-63068fb9c096.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/pa/media/5110-pennell-rd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=4979469368574250528&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "39.8698742",
      "poi_longitude": "-75.42792399999999",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 484-440-9965",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1a0d-7058-a1d7-1d0607eaf6a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1a0d-7058-a1d7-1d0607eaf6a9",
        "storage_key": "property/6767906449166310/019d0266-1a0d-7058-a1d7-1d0607eaf6a9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJsSI93QPmxokRII7OIwKhGkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_a6daef79-c710-4d51-bcfa-434681542a42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "2370 Dutton Mill Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-b183-727b-8d79-f2689fb4b055.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-b183-727b-8d79-f2689fb4b055",
        "storage_key": "property/6767906449166310/019d0265-b183-727b-8d79-f2689fb4b055.webp",
        "width": 1280,
        "height": 911
      },
      "poi_business_url": "https://www.7-eleven.com/locations/pa/aston/2370-dutton-mill-rd-11323?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=8385245211829480036&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "39.8643852",
      "poi_longitude": "-75.4166504",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 610-485-1287",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-19f6-73c3-b4a1-393fdc61d06e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-19f6-73c3-b4a1-393fdc61d06e",
        "storage_key": "property/6767906449166310/019d0266-19f6-73c3-b4a1-393fdc61d06e.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJN-xp-CDmxokRZCqk3RdgXnQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_965f79c8-0f17-43a3-88be-3a7022de199b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Rite Aid",
      "poi_type": "Shopping & Retail",
      "poi_address": "4400 Pennell Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-b1ca-74cc-8080-97a6c375a5f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-b1ca-74cc-8080-97a6c375a5f5",
        "storage_key": "property/6767906449166310/019d0265-b1ca-74cc-8080-97a6c375a5f5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.riteaid.com/locations/pa/aston/4400-pennell-road.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11562924744037916531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rite-aid",
      "poi_latitude": "39.85687009999999",
      "poi_longitude": "-75.42653299999999",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 610-494-2055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-19f2-718d-b2a0-91954f5ebbc5",
        "storage_key": "property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6r6LwzmxokRc1_0rMrCd6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_aaeaff29-fce2-4b98-83bb-c5cc536226b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Walmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "605 Conchester Hwy, Boothwyn, PA 19061, USA",
      "poi_short_description": "Clean, well-stocked big-box department store carrying everything from electronics to clothing, plus groceries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-b38e-74ca-b47b-22bb56d6f8f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-b38e-74ca-b47b-22bb56d6f8f5",
        "storage_key": "property/6767906449166310/019d0265-b38e-74ca-b47b-22bb56d6f8f5.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/3252-boothwyn-pa?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14387228082865720250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart",
      "poi_latitude": "39.8519398",
      "poi_longitude": "-75.4492537",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-494-2535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1a0d-7058-a1d7-1d0607eaf6a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1a0d-7058-a1d7-1d0607eaf6a9",
        "storage_key": "property/6767906449166310/019d0266-1a0d-7058-a1d7-1d0607eaf6a9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ66THYsPlxokRuku87bazqcc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_595dbd41-3db7-40ce-9285-4282a6b44165",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Pennell Elementary School",
      "poi_type": "Education",
      "poi_address": "3300 Richard Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://pennell.pdsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8054970275392150225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pennell-elementary-school",
      "poi_latitude": "39.8625018",
      "poi_longitude": "-75.4295975",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 610-497-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1a4c-738c-83fb-c51a133ec465",
        "storage_key": "property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO9PeEgbmxokR0VoU1ckAyW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_54fcacbc-5219-4b7a-9523-7c4246629b25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Aston Elementary School",
      "poi_type": "Education",
      "poi_address": "900 Tryens Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://aston.pdsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=417210306882344338&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aston-elementary-school",
      "poi_latitude": "39.8705366",
      "poi_longitude": "-75.4422068",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-497-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1a4c-738c-83fb-c51a133ec465",
        "storage_key": "property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJT4qRefnlxokRkpVaSpA6ygU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_2351e9a6-933a-4fe0-b37c-3c8413dc5c04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Northley Middle School",
      "poi_type": "Education",
      "poi_address": "2801 Concord Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-b722-77ea-9816-fe1b1faf9577.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-b722-77ea-9816-fe1b1faf9577",
        "storage_key": "property/6767906449166310/019d0265-b722-77ea-9816-fe1b1faf9577.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nms.pdsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1080462886129639715&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northley-middle-school",
      "poi_latitude": "39.8598225",
      "poi_longitude": "-75.412412",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 610-497-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1a4c-738c-83fb-c51a133ec465",
        "storage_key": "property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJddZnHhHmxokRIyHAOEWT_g4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_56638724-5100-4626-b7ea-867c8e1941a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Sun Valley High School",
      "poi_type": "Education",
      "poi_address": "2881 Pancoast Ave, Aston Township, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-bab2-7339-8981-7279f14cfd8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-bab2-7339-8981-7279f14cfd8d",
        "storage_key": "property/6767906449166310/019d0265-bab2-7339-8981-7279f14cfd8d.webp",
        "width": 558,
        "height": 290
      },
      "poi_business_url": "http://www.pdsd.org/svhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=16742821752922634979&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sun-valley-high-school",
      "poi_latitude": "39.8585439",
      "poi_longitude": "-75.41689",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-497-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1a4c-738c-83fb-c51a133ec465",
        "storage_key": "property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJddZnHhHmxokR4_qiUK1zWug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_c5642c50-86af-497d-ba3b-995c8bede19e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Delaware County Tech High School",
      "poi_type": "Education",
      "poi_address": "100 Crozerville Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10460432019784694219&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "delaware-county-tech-high-school",
      "poi_latitude": "39.882336",
      "poi_longitude": "-75.4536881",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 610-459-3050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1a4c-738c-83fb-c51a133ec465",
        "storage_key": "property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0122yF3vxokRy3ljEIDrKpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_de3a1d57-2e21-4b12-9975-2acfd5c2758e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Neumann University",
      "poi_type": "Education",
      "poi_address": "1 Neumann Dr, Aston Township, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-bbd3-74ce-94b2-b9131a1c46ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-bbd3-74ce-94b2-b9131a1c46ee",
        "storage_key": "property/6767906449166310/019d0265-bbd3-74ce-94b2-b9131a1c46ee.webp",
        "width": 1000,
        "height": 600
      },
      "poi_business_url": "https://www.neumann.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10264411917586710895&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "neumann-university",
      "poi_latitude": "39.8753223",
      "poi_longitude": "-75.4408041",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-459-0905",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1a4c-738c-83fb-c51a133ec465",
        "storage_key": "property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCyvMDFbvxokRb8EKgEGEco4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_452097fe-391f-4a12-87c7-b1c55c9f1615",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Holy Family Regional Catholic School",
      "poi_type": "Education",
      "poi_address": "3265 Concord Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://holyfamilyaston.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12125298321556699966&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holy-family-regional-catholic-school",
      "poi_latitude": "39.8657036",
      "poi_longitude": "-75.420271",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-494-0147",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1a4c-738c-83fb-c51a133ec465",
        "storage_key": "property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnTuFdhvmxokRPvsGtJS2Rag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_3a7d3bb8-d636-43b5-bbf4-58d58f81b172",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Aston KinderCare",
      "poi_type": "Education",
      "poi_address": "5016 Pennell Rd, Aston, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-bb93-726f-a6b6-b85fce9233c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-bb93-726f-a6b6-b85fce9233c4",
        "storage_key": "property/6767906449166310/019d0265-bb93-726f-a6b6-b85fce9233c4.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/aston/pa/301319?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_NTA3NzcyLTcxNS1sb2NhdGlvbi53ZWJzaXRl",
      "poi_directions_map_url": "https://maps.google.com/?cid=15354463651014743490&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aston-kindercare",
      "poi_latitude": "39.8669489",
      "poi_longitude": "-75.42731289999999",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 610-494-6202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1a4c-738c-83fb-c51a133ec465",
        "storage_key": "property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJte781QPmxokRwpVh01YDFtU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_2ca461c8-57a6-4845-980d-2ad9d2f4f998",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Media Children's House Montessori School",
      "poi_type": "Education",
      "poi_address": "3301 Concord Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.mediachildrenshouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7431748416986659856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "media-childrens-house-montessori-school",
      "poi_latitude": "39.8667031",
      "poi_longitude": "-75.4214286",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 610-485-8950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1a4c-738c-83fb-c51a133ec465",
        "storage_key": "property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlXsHcgHmxokRELyPZs_fImc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_ef5c00ac-0caa-4535-8064-32c880538181",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Coebourn Elementary School",
      "poi_type": "Education",
      "poi_address": "1 Coebourn Blvd, Brookhaven, PA 19015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-c03c-7787-8071-ab64016d501a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-c03c-7787-8071-ab64016d501a",
        "storage_key": "property/6767906449166310/019d0265-c03c-7787-8071-ab64016d501a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://coebourn.pdsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16385963997487688529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coebourn-elementary-school",
      "poi_latitude": "39.8740246",
      "poi_longitude": "-75.3943086",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-497-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1a4c-738c-83fb-c51a133ec465",
        "storage_key": "property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu5rmhIboxokRUeuXbHCjZuM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_91c8cedb-d854-415a-98af-ac9d50999028",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Regal Brandywine Town Center",
      "poi_type": "Entertainment",
      "poi_address": "3300 Brandywine Pkwy, Wilmington, DE 19803, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-c2ac-76da-a275-4e988668eeba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-c2ac-76da-a275-4e988668eeba",
        "storage_key": "property/6767906449166310/019d0265-c2ac-76da-a275-4e988668eeba.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-brandywine-town-center-0509?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=9048418590067935308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-brandywine-town-center",
      "poi_latitude": "39.8333168",
      "poi_longitude": "-75.5358505",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1e51-760e-b1c8-a0ff0328a315.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1e51-760e-b1c8-a0ff0328a315",
        "storage_key": "property/6767906449166310/019d0266-1e51-760e-b1c8-a0ff0328a315.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJrUbAdTr7xokRTEgKYMRwkn0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_62e7f739-277a-42c5-87da-7e8cc3480a04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Penn Cinema Riverfront 14 + IMAX",
      "poi_type": "Entertainment",
      "poi_address": "401 S Madison St, Wilmington, DE 19801, USA",
      "poi_short_description": "Movie theater with IMAX & 3D capability screening first-run films & classic movies occasionally.",
      "poi_long_description": "Movie theater with IMAX & 3D capability screening first-run films & classic movies occasionally.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-c371-772f-9a1f-38bc9fe5f4b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-c371-772f-9a1f-38bc9fe5f4b0",
        "storage_key": "property/6767906449166310/019d0265-c371-772f-9a1f-38bc9fe5f4b0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.penncinema.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7629650129538754770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "penn-cinema-riverfront-14--imax",
      "poi_latitude": "39.7359106",
      "poi_longitude": "-75.5621147",
      "poi_miles_from_property": "13.3",
      "poi_walking_minutes": "4 hours 57 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 302-656-4314",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1e51-760e-b1c8-a0ff0328a315.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1e51-760e-b1c8-a0ff0328a315",
        "storage_key": "property/6767906449166310/019d0266-1e51-760e-b1c8-a0ff0328a315.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJuwbnJWX9xokR0qirg1724Wk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_4026e6aa-e287-4e23-8198-2abd7da87c68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "AMC DINE-IN Painters Crossing 9",
      "poi_type": "Entertainment",
      "poi_address": "112 Wilmington Pike, West Chester, PA 19382, USA",
      "poi_short_description": "Movie theater chain offering a range of food options from full-service dining to express pick-up.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-c2c7-72f7-a20d-90b4fb72641d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-c2c7-72f7-a20d-90b4fb72641d",
        "storage_key": "property/6767906449166310/019d0265-c2c7-72f7-a20d-90b4fb72641d.webp",
        "width": 565,
        "height": 317
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/philadelphia/amc-dine-in-painters-crossing-9?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4817773078838835324&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-dine-in-painters-crossing-9",
      "poi_latitude": "39.8826826",
      "poi_longitude": "-75.55015449999999",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 610-558-4814",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1e51-760e-b1c8-a0ff0328a315.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1e51-760e-b1c8-a0ff0328a315",
        "storage_key": "property/6767906449166310/019d0266-1e51-760e-b1c8-a0ff0328a315.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJnXcbeWPwxokRfPig7BYr3EI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_b0a0d40d-c700-428c-886e-9eb4043da5ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "The Grand Opera House",
      "poi_type": "Entertainment",
      "poi_address": "818 N King St, Wilmington, DE 19801, USA",
      "poi_short_description": "Opulent 1871 building featuring opera, symphony, ballet & other live performances.",
      "poi_long_description": "Opulent 1871 building featuring opera, symphony, ballet & other live performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-c704-70d3-90a4-35c728347541.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-c704-70d3-90a4-35c728347541",
        "storage_key": "property/6767906449166310/019d0265-c704-70d3-90a4-35c728347541.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.thegrandwilmington.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18059826858776847348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-grand-opera-house",
      "poi_latitude": "39.7438908",
      "poi_longitude": "-75.54870679999999",
      "poi_miles_from_property": "12.6",
      "poi_walking_minutes": "4 hours 41 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 302-652-5577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-19f2-718d-b2a0-91954f5ebbc5",
        "storage_key": "property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ37FAr0H9xokR9ONzztdkofo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "opera_house"
    },
    {
      "id": "custom_98575c4c-c266-4a4d-84a3-c10552e38fc8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Delaware Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "2301 Kentmere Pkwy, Wilmington, DE 19806, USA",
      "poi_short_description": "Galleries featuring pre-Raphaelite art, Brandywine school illustrators & 9-acre sculpture garden.",
      "poi_long_description": "Galleries featuring pre-Raphaelite art, Brandywine school illustrators & 9-acre sculpture garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-cb20-76ca-af48-7384994b2d43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-cb20-76ca-af48-7384994b2d43",
        "storage_key": "property/6767906449166310/019d0265-cb20-76ca-af48-7384994b2d43.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://delart.org/?utm_source=GMBListing&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=10706770182934760165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "delaware-art-museum",
      "poi_latitude": "39.76529",
      "poi_longitude": "-75.5650454",
      "poi_miles_from_property": "12.2",
      "poi_walking_minutes": "4 hours 31 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 302-571-9590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1f1b-7737-8e0f-33ee016014db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1f1b-7737-8e0f-33ee016014db",
        "storage_key": "property/6767906449166310/019d0266-1f1b-7737-8e0f-33ee016014db.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJe5tvDgP9xokR5QqSJcEWlpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_0df3f413-ce48-4ca6-9060-a4993ad7531f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Brandywine Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "1 Hoffmans Mill Rd, Chadds Ford, PA 19317, USA",
      "poi_short_description": "Gristmill-turned-museum with paintings by Howard Pyle, N.C. Wyeth & others plus big windows & views.",
      "poi_long_description": "Gristmill-turned-museum with paintings by Howard Pyle, N.C. Wyeth & others plus big windows & views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-cd04-77fe-986f-c400a3e2bc47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-cd04-77fe-986f-c400a3e2bc47",
        "storage_key": "property/6767906449166310/019d0265-cd04-77fe-986f-c400a3e2bc47.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.brandywine.org/museum",
      "poi_directions_map_url": "https://maps.google.com/?cid=10869885462131337207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brandywine-museum-of-art",
      "poi_latitude": "39.870009",
      "poi_longitude": "-75.593158",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 610-388-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1f1b-7737-8e0f-33ee016014db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1f1b-7737-8e0f-33ee016014db",
        "storage_key": "property/6767906449166310/019d0266-1f1b-7737-8e0f-33ee016014db.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJrWwPE0H6xokR92eFlzyX2ZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_124a43e9-49c6-44e1-a9a1-bbee0c2f4b6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Brandywine Zoo",
      "poi_type": "Entertainment",
      "poi_address": "1001 N Park Dr, Wilmington, DE 19802, USA",
      "poi_short_description": "Zoo in Brandywine Park with lemurs, capybaras & bobcats, plus condors & eagles.",
      "poi_long_description": "Zoo in Brandywine Park with lemurs, capybaras & bobcats, plus condors & eagles.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-cf19-76bf-8ff7-bbc0e2da4575.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-cf19-76bf-8ff7-bbc0e2da4575",
        "storage_key": "property/6767906449166310/019d0265-cf19-76bf-8ff7-bbc0e2da4575.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "http://www.brandywinezoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1292192698743185202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brandywine-zoo",
      "poi_latitude": "39.7559835",
      "poi_longitude": "-75.5496828",
      "poi_miles_from_property": "11.9",
      "poi_walking_minutes": "4 hours 25 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 302-571-7788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-19f2-718d-b2a0-91954f5ebbc5",
        "storage_key": "property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa4A1Ej39xokRMt_wxWnK7hE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_6a83c7e7-093a-457b-8e60-68d5ed0a1e6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Nemours Estate",
      "poi_type": "Entertainment",
      "poi_address": "1600 Rockland Rd, Wilmington, DE 19803, USA",
      "poi_short_description": "DuPont family estate featuring a 102-room Louis XVI-style chateau & antiques, plus 100-acre gardens.",
      "poi_long_description": "DuPont family estate featuring a 102-room Louis XVI-style chateau & antiques, plus 100-acre gardens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-d228-777c-9359-3ed537c9f79a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-d228-777c-9359-3ed537c9f79a",
        "storage_key": "property/6767906449166310/019d0265-d228-777c-9359-3ed537c9f79a.webp",
        "width": 1280,
        "height": 844
      },
      "poi_business_url": "http://www.nemoursestate.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16551884357353133980&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nemours-estate",
      "poi_latitude": "39.7766433",
      "poi_longitude": "-75.5581243",
      "poi_miles_from_property": "11",
      "poi_walking_minutes": "4 hours 7 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 302-651-6912",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1f1b-7737-8e0f-33ee016014db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1f1b-7737-8e0f-33ee016014db",
        "storage_key": "property/6767906449166310/019d0266-1f1b-7737-8e0f-33ee016014db.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJvZJcQun8xokRnNdgmyAbtOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_901dd650-5b64-478a-8ad7-fcee165dd8c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Bette's Family Fun Center",
      "poi_type": "Entertainment",
      "poi_address": "2971 W Dutton Mill Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "Expansive indoor play area offering inflatable structures, video games & slides, plus a snack bar.",
      "poi_long_description": "Expansive indoor play area offering inflatable structures, video games & slides, plus a snack bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-d380-7686-9bf3-ae64dd5194e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-d380-7686-9bf3-ae64dd5194e5",
        "storage_key": "property/6767906449166310/019d0265-d380-7686-9bf3-ae64dd5194e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bettesfuncenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14939624342790963829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bettes-family-fun-center",
      "poi_latitude": "39.8568232",
      "poi_longitude": "-75.42064649999999",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 484-480-4789",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-19f2-718d-b2a0-91954f5ebbc5",
        "storage_key": "property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyXTRGxHmxokRdYLVrS81VM8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_ae8b2357-53fe-4ebd-a3f6-1ed6759c246a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Riddle Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1068 W Baltimore Pike, Media, PA 19063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-d3b3-71f8-9b77-22065eaa1b1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-d3b3-71f8-9b77-22065eaa1b1f",
        "storage_key": "property/6767906449166310/019d0265-d3b3-71f8-9b77-22065eaa1b1f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mainlinehealth.org/locations/riddle-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=3559744642463859310&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riddle-hospital",
      "poi_latitude": "39.9125335",
      "poi_longitude": "-75.4308225",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 484-227-9400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1f29-7079-83ec-176aae725750.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1f29-7079-83ec-176aae725750",
        "storage_key": "property/6767906449166310/019d0266-1f29-7079-83ec-176aae725750.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJoQW1airpxokRboIoWeTAZjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_924f6f33-7990-42cc-bd55-d17ffbd148c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "AFC Urgent Care Aston",
      "poi_type": "Health and Wellness",
      "poi_address": "5024 Pennell Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-d643-7720-8342-6fb627972c21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-d643-7720-8342-6fb627972c21",
        "storage_key": "property/6767906449166310/019d0265-d643-7720-8342-6fb627972c21.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.afcurgentcare.com/aston/?utm_source=gmb&utm_medium=organic&utm_campaign=afc-aston-gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=14309820229190060088&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "afc-urgent-care-aston",
      "poi_latitude": "39.8670094",
      "poi_longitude": "-75.42778109999999",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 484-766-3502",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-19f2-718d-b2a0-91954f5ebbc5",
        "storage_key": "property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEdK8-APmxokROIiSiK6xlsY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_6e435788-a221-4560-b545-62abfc729b81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4952 Pennell Rd, Aston, PA 19014, USA",
      "poi_short_description": "Chain gym with tanning, massage chairs, and open hours.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-da40-700f-a703-37a3e5afab9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-da40-700f-a703-37a3e5afab9b",
        "storage_key": "property/6767906449166310/019d0265-da40-700f-a703-37a3e5afab9b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/aston-pa?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=4992089956174438922&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.8636923",
      "poi_longitude": "-75.4265667",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 610-485-0800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-19f2-718d-b2a0-91954f5ebbc5",
        "storage_key": "property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY4Dz1QPmxokRCqKSrF13R0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_98444775-3144-4a51-b8ab-9ac14e3fcad3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Pinnacle Athletic Center (The PAC)",
      "poi_type": "Health and Wellness",
      "poi_address": "4401 Pennell Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-dbc2-7309-88d7-47463400ccaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-dbc2-7309-88d7-47463400ccaa",
        "storage_key": "property/6767906449166310/019d0265-dbc2-7309-88d7-47463400ccaa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://pac-fitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3999161964900376390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinnacle-athletic-center-the-pac",
      "poi_latitude": "39.8564758",
      "poi_longitude": "-75.4287719",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 484-480-3515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-19f2-718d-b2a0-91954f5ebbc5",
        "storage_key": "property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJya65nrLnxokRRt8jXZ7gfzc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_768db8ad-4593-4dbe-8dbe-47cce809cedc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Retro Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4443 Pennell Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-dc95-71c7-8ddd-b41eaa016223.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-dc95-71c7-8ddd-b41eaa016223",
        "storage_key": "property/6767906449166310/019d0265-dc95-71c7-8ddd-b41eaa016223.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://retrofitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=700054143010105723&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "retro-fitness",
      "poi_latitude": "39.8564224",
      "poi_longitude": "-75.42855829999999",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 484-480-6968",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-19f2-718d-b2a0-91954f5ebbc5",
        "storage_key": "property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYzfng7mxokRe2motYgXtwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1f30dffb-2fa6-42f6-a404-e41bb91dc283",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Fuel House Fitness Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "4912 Pennell Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "Fitness studio offering a variety of classes, including Zumba, in an encouraging environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-df60-740e-b772-f5f2f5800e44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-df60-740e-b772-f5f2f5800e44",
        "storage_key": "property/6767906449166310/019d0265-df60-740e-b772-f5f2f5800e44.webp",
        "width": 1242,
        "height": 876
      },
      "poi_business_url": "http://www.getfuelfit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9808539485655253733&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fuel-house-fitness-studio",
      "poi_latitude": "39.8626556",
      "poi_longitude": "-75.4266163",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 610-800-8243",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-19f2-718d-b2a0-91954f5ebbc5",
        "storage_key": "property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb3XD8QXmxokR5cLfv7HuHog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_a484f2d2-a6bc-4b90-bb41-8497ae186ecc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Higher Ground Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "4600 Pennell Rd UNIT C, Aston Township, PA 19014, USA",
      "poi_short_description": "Yoga studio offering a variety of classes (including slow flow and recovery) for all levels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-e278-778a-88f8-b45c1077dcb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-e278-778a-88f8-b45c1077dcb0",
        "storage_key": "property/6767906449166310/019d0265-e278-778a-88f8-b45c1077dcb0.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.yogahigherground.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15890453614902103570&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "higher-ground-yoga",
      "poi_latitude": "39.8581422",
      "poi_longitude": "-75.4267125",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 484-442-0206",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1a4c-738c-83fb-c51a133ec465",
        "storage_key": "property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDQyC4hXnxokREs4PHF87htw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_5a13c225-152c-4c6a-a06d-632df619b671",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Weir Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2201 Weir Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16294337960017701586&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "weir-park",
      "poi_latitude": "39.8604735",
      "poi_longitude": "-75.439753",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1f2a-716f-8c99-164c892c4c29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1f2a-716f-8c99-164c892c4c29",
        "storage_key": "property/6767906449166310/019d0266-1f2a-716f-8c99-164c892c4c29.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAjePlxokR0qoEJQseIeI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a0467896-f7f7-49a4-9bb8-194375085aba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Aston Community Center & Library",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3270 Concord Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "Clean community center featuring a library and a playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-e359-702e-93a6-a6565f0e539a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-e359-702e-93a6-a6565f0e539a",
        "storage_key": "property/6767906449166310/019d0265-e359-702e-93a6-a6565f0e539a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14509415423664366634&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aston-community-center--library",
      "poi_latitude": "39.86762239999999",
      "poi_longitude": "-75.42075799999999",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-497-1255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-19f2-718d-b2a0-91954f5ebbc5",
        "storage_key": "property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH6V6kRzmxokRKqQWInTMW8k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "custom_fefe3fe1-2f3c-43f7-9266-665566012f4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Chester Creek Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "249 Knowlton Rd, Media, PA 19063, USA",
      "poi_short_description": "Flat paved trail taking in views of the surrounding nature as well as the occasional road crossing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-e59d-77ba-ab3d-bd331ffdce05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-e59d-77ba-ab3d-bd331ffdce05",
        "storage_key": "property/6767906449166310/019d0265-e59d-77ba-ab3d-bd331ffdce05.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.chestercreektrail.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8756719794264460440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chester-creek-trail",
      "poi_latitude": "39.8766598",
      "poi_longitude": "-75.4164474",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-891-4663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1f2a-716f-8c99-164c892c4c29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1f2a-716f-8c99-164c892c4c29",
        "storage_key": "property/6767906449166310/019d0266-1f2a-716f-8c99-164c892c4c29.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRV9Vu0fvxokRmMzD_kEehnk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_db97fd08-4e68-492e-baf4-e2ae907093af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Linvilla Orchards",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "137 W Knowlton Rd, Media, PA 19063, USA",
      "poi_short_description": "U-pick apples & pumpkins at a farm store selling cider, seasonal local produce & baked goods.",
      "poi_long_description": "U-pick apples & pumpkins at a farm store selling cider, seasonal local produce & baked goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-cad4-779a-a9b4-4bcd82e539e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-cad4-779a-a9b4-4bcd82e539e8",
        "storage_key": "property/6767906449166310/019d0265-cad4-779a-a9b4-4bcd82e539e8.webp",
        "width": 491,
        "height": 276
      },
      "poi_business_url": "http://www.linvilla.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1355189386840341447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "linvilla-orchards",
      "poi_latitude": "39.8837311",
      "poi_longitude": "-75.4136024",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 610-876-7116",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1585-7469-b4f5-ca5433fcdaa7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1585-7469-b4f5-ca5433fcdaa7",
        "storage_key": "property/6767906449166310/019d0266-1585-7469-b4f5-ca5433fcdaa7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvTw_ob3oxokRx3v_NZGZzhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_15c1cdbf-b46e-49ba-9b71-60da4ef24b43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Ridley Creek State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1023 Sycamore Mills Rd, Media, PA 19063, USA",
      "poi_short_description": "Green oasis of woodlands & meadows offering hiking, fishing & picnicking from sunrise to sunset.",
      "poi_long_description": "Green oasis of woodlands & meadows offering hiking, fishing & picnicking from sunrise to sunset.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-e6ad-7728-95ee-4dabf611d524.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-e6ad-7728-95ee-4dabf611d524",
        "storage_key": "property/6767906449166310/019d0265-e6ad-7728-95ee-4dabf611d524.webp",
        "width": 1160,
        "height": 762
      },
      "poi_business_url": "https://www.dcnr.pa.gov/StateParks/FindAPark/RidleyCreekStatePark/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=5448215149411273656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ridley-creek-state-park",
      "poi_latitude": "39.951373",
      "poi_longitude": "-75.44404349999999",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 610-892-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1f2a-716f-8c99-164c892c4c29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1f2a-716f-8c99-164c892c4c29",
        "storage_key": "property/6767906449166310/019d0266-1f2a-716f-8c99-164c892c4c29.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJY5RrYw1KtokRuIuPANDym0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_40e6a885-6012-46a7-8b9b-7c7d68cf300d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Tyler Arboretum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "515 Painter Rd, Media, PA 19063, USA",
      "poi_short_description": "Also known as Minshall & Jacob Painter Farm, this 650-acre tree park has a pinetum & woodland walk.",
      "poi_long_description": "Also known as Minshall & Jacob Painter Farm, this 650-acre tree park has a pinetum & woodland walk.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-ed12-7572-b4b3-3796b96c3b99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-ed12-7572-b4b3-3796b96c3b99",
        "storage_key": "property/6767906449166310/019d0265-ed12-7572-b4b3-3796b96c3b99.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://tylerarboretum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15131317346627032980&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tyler-arboretum",
      "poi_latitude": "39.9345237",
      "poi_longitude": "-75.4428038",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 610-566-9134",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1f2a-716f-8c99-164c892c4c29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1f2a-716f-8c99-164c892c4c29",
        "storage_key": "property/6767906449166310/019d0266-1f2a-716f-8c99-164c892c4c29.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2dyGQUvpxokRlBdpJfU8_dE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_9360f4bd-2416-442a-b340-5c090f16a69f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "John Heinz National Wildlife Refuge at Tinicum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8601 Lindbergh Blvd., Philadelphia, PA 19153, USA",
      "poi_short_description": "Dedicated to preserving the Tinicum Marsh, this refuge offers hiking trails & a visitor center.",
      "poi_long_description": "Dedicated to preserving the Tinicum Marsh, this refuge offers hiking trails & a visitor center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-ed40-7711-851a-af3c976eac31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-ed40-7711-851a-af3c976eac31",
        "storage_key": "property/6767906449166310/019d0265-ed40-7711-851a-af3c976eac31.webp",
        "width": 1280,
        "height": 879
      },
      "poi_business_url": "http://www.fws.gov/refuge/john_heinz/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4770527280977373682&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-heinz-national-wildlife-refuge-at-tinicum",
      "poi_latitude": "39.8921524",
      "poi_longitude": "-75.2572137",
      "poi_miles_from_property": "12.3",
      "poi_walking_minutes": "4 hours 30 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 215-365-3118",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1f2a-716f-8c99-164c892c4c29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1f2a-716f-8c99-164c892c4c29",
        "storage_key": "property/6767906449166310/019d0266-1f2a-716f-8c99-164c892c4c29.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2SMy_xLDxokR8mn3ZUlRNEI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wildlife_refuge"
    },
    {
      "id": "custom_a3ef8aa1-f0c5-4ed1-9637-68facf7d907d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Lewis H Fisher Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Mount Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5604600340655145771&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewis-h-fisher-memorial-park",
      "poi_latitude": "39.8797971",
      "poi_longitude": "-75.4474911",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1f2a-716f-8c99-164c892c4c29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1f2a-716f-8c99-164c892c4c29",
        "storage_key": "property/6767906449166310/019d0266-1f2a-716f-8c99-164c892c4c29.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__8_81nvxokRK4PIvFCKx00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a07ea1dd-1de6-46c3-89aa-30796400821e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Concord Square Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Surrey Ln, Aston Township, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7956177330590163146&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concord-square-park",
      "poi_latitude": "39.8661288",
      "poi_longitude": "-75.4372039",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1f2a-716f-8c99-164c892c4c29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1f2a-716f-8c99-164c892c4c29",
        "storage_key": "property/6767906449166310/019d0266-1f2a-716f-8c99-164c892c4c29.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAAf3lxokRyqDX5yAFam4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_36ba8a5d-d02f-44bd-b970-7cfe7dc9885b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Bridgewater Farms Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2137 N Bent Ln, Aston Township, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-f1f5-75d0-8eef-e4faf05d96fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-f1f5-75d0-8eef-e4faf05d96fa",
        "storage_key": "property/6767906449166310/019d0265-f1f5-75d0-8eef-e4faf05d96fa.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://astontownship.net/community-news/parks-recreation/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6379836729445483617&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bridgewater-farms-park",
      "poi_latitude": "39.860011",
      "poi_longitude": "-75.4043587",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1f2a-716f-8c99-164c892c4c29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1f2a-716f-8c99-164c892c4c29",
        "storage_key": "property/6767906449166310/019d0266-1f2a-716f-8c99-164c892c4c29.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWzy8MNLnxokRYYSWH7S7iVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d2ff575c-75c6-48be-97fd-46e892f85a35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Marcus Hook",
      "poi_type": "Transportation & Transit",
      "poi_address": "20 W 12th St, Marcus Hook, PA 19061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-f13c-7059-b900-35a39920fd98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-f13c-7059-b900-35a39920fd98",
        "storage_key": "property/6767906449166310/019d0265-f13c-7059-b900-35a39920fd98.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.septa.org/stations/rail/marcushook.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=6351715583461092514&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marcus-hook",
      "poi_latitude": "39.8215162",
      "poi_longitude": "-75.4196645",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 610-485-3294",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-234c-764b-b60f-f083c719436d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-234c-764b-b60f-f083c719436d",
        "storage_key": "property/6767906449166310/019d0266-234c-764b-b60f-f083c719436d.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJb8GnKY7mxokRouyCmqvTJVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_cd030b64-35be-4fee-b6bd-8e704edc3b0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Chester Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "595 Avenue of the States, Chester, PA 19013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-f585-7256-8a3c-a70a1427d54c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-f585-7256-8a3c-a70a1427d54c",
        "storage_key": "property/6767906449166310/019d0265-f585-7256-8a3c-a70a1427d54c.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "http://www.septa.org/stations/rail/chestertc.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=13429225762141766686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chester-transit-center",
      "poi_latitude": "39.8493518",
      "poi_longitude": "-75.35987109999999",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-234c-764b-b60f-f083c719436d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-234c-764b-b60f-f083c719436d",
        "storage_key": "property/6767906449166310/019d0266-234c-764b-b60f-f083c719436d.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJpwo0QunnxokRHgT8-K0xXro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_b3d95379-329f-4a8b-ab0d-4907aca43728",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Claymont",
      "poi_type": "Transportation & Transit",
      "poi_address": "200 Myrtle Ave, Claymont, DE 19703, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-f61c-7129-9d03-32e939ad1669.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-f61c-7129-9d03-32e939ad1669",
        "storage_key": "property/6767906449166310/019d0265-f61c-7129-9d03-32e939ad1669.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.septa.org/stations/rail/claymont.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=6593283050880375847&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "claymont",
      "poi_latitude": "39.79772579999999",
      "poi_longitude": "-75.4523299",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-580-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-234c-764b-b60f-f083c719436d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-234c-764b-b60f-f083c719436d",
        "storage_key": "property/6767906449166310/019d0266-234c-764b-b60f-f083c719436d.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJc8_y1AvkxokRJxxUhwAMgFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_cf11d9eb-1ee7-42ea-926e-c32b5a370ff7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Wilmington",
      "poi_type": "Transportation & Transit",
      "poi_address": "100 French St, Wilmington, DE 19801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-f997-707f-b86b-804206a2e472.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-f997-707f-b86b-804206a2e472",
        "storage_key": "property/6767906449166310/019d0265-f997-707f-b86b-804206a2e472.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=WIL",
      "poi_directions_map_url": "https://maps.google.com/?cid=7825201090715334340&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wilmington",
      "poi_latitude": "39.7371953",
      "poi_longitude": "-75.5512614",
      "poi_miles_from_property": "13.1",
      "poi_walking_minutes": "4 hours 51 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-234c-764b-b60f-f083c719436d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-234c-764b-b60f-f083c719436d",
        "storage_key": "property/6767906449166310/019d0266-234c-764b-b60f-f083c719436d.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJbZWF-2f9xokRxDYWrO6ymGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_50bd32d7-5915-48c2-8a0b-1389e72ffb14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Wilmington Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "151 N Dupont Hwy, New Castle, DE 19720, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-fc70-716c-b2d9-198e9973ac2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-fc70-716c-b2d9-198e9973ac2b",
        "storage_key": "property/6767906449166310/019d0265-fc70-716c-b2d9-198e9973ac2b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://flyilg.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1083455709425976738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wilmington-airport",
      "poi_latitude": "39.6790169",
      "poi_longitude": "-75.60703960000001",
      "poi_miles_from_property": "22.8",
      "poi_walking_minutes": "8 hours 26 mins",
      "poi_biking_minutes": "1 hour 56 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 302-325-5124",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-2396-71da-998f-157526e4594e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2396-71da-998f-157526e4594e",
        "storage_key": "property/6767906449166310/019d0266-2396-71da-998f-157526e4594e.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJMbyqscQDx4kRokU0Mjo1CQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_59b54eaf-f2ce-4e09-ab13-e7e398e4a65d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "8000 Essington Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "8000 Essington Ave, Philadelphia, PA 19153, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3940177627801768097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "8000-essington-ave",
      "poi_latitude": "39.8709941",
      "poi_longitude": "-75.26416499999999",
      "poi_miles_from_property": "10.9",
      "poi_walking_minutes": "3 hours 59 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-19f2-718d-b2a0-91954f5ebbc5",
        "storage_key": "property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi6RdEkLDxokRodAQMa1SrjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "premise"
    },
    {
      "id": "custom_6bdfa5bd-2a98-49e7-b5f5-46a118df9db9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Pennell Rd & Knowlton Rd - FS",
      "poi_type": "Transportation & Transit",
      "poi_address": "Aston Township, PA 19063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15693844002194388962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pennell-rd--knowlton-rd---fs",
      "poi_latitude": "39.869595",
      "poi_longitude": "-75.428406",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-19f2-718d-b2a0-91954f5ebbc5",
        "storage_key": "property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG_FD1wPmxokR4vcwb_i7y9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_2360981b-999a-4949-aea9-2d7d1492f42d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Pennsylvania Tire & Auto of Aston",
      "poi_type": "Transportation & Transit",
      "poi_address": "3211 Concord Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "Auto repair shop offering services such as oil changes and inspections, plus appointments.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-fe58-73ea-9629-9d5dc5b94c92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-fe58-73ea-9629-9d5dc5b94c92",
        "storage_key": "property/6767906449166310/019d0265-fe58-73ea-9629-9d5dc5b94c92.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.patireauto.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1269310563012100329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pennsylvania-tire--auto-of-aston",
      "poi_latitude": "39.8647431",
      "poi_longitude": "-75.417937",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-497-1339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-19f2-718d-b2a0-91954f5ebbc5",
        "storage_key": "property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlXsHcgHmxokR6cD8YTt_nRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "car_repair"
    },
    {
      "id": "custom_c1778807-24fe-479a-b0ab-038d8f63b1e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Penn-Delco School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2821 Concord Rd, Aston Township, PA 19014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0265-fe6c-774a-bec8-a47050363b48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-fe6c-774a-bec8-a47050363b48",
        "storage_key": "property/6767906449166310/019d0265-fe6c-774a-bec8-a47050363b48.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "http://www.pdsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7345094084059730821&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "penn-delco-school-district",
      "poi_latitude": "39.8611351",
      "poi_longitude": "-75.4131455",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 610-497-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1a4c-738c-83fb-c51a133ec465",
        "storage_key": "property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkwAQWBzmxokRhRM0SicE72U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ea0464ac-5df1-4ea6-895a-cb7f61196687",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Penn State Brandywine",
      "poi_type": "Major Employers & Offices",
      "poi_address": "25 Yearsley Mill Rd, Media, PA 19063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-03cb-7519-8907-afafa334bf34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-03cb-7519-8907-afafa334bf34",
        "storage_key": "property/6767906449166310/019d0266-03cb-7519-8907-afafa334bf34.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://brandywine.psu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16402217972630522699&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "penn-state-brandywine",
      "poi_latitude": "39.9263837",
      "poi_longitude": "-75.4470628",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 610-892-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1a4c-738c-83fb-c51a133ec465",
        "storage_key": "property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp7kJUsXuxokRS4sr61dioOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c9830a60-bde0-434e-8c82-28d5e0296fe0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Delaware County Community College",
      "poi_type": "Major Employers & Offices",
      "poi_address": "901 Media Line Rd, Media, PA 19063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-043d-7633-83eb-5b52d1cd9165.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-043d-7633-83eb-5b52d1cd9165",
        "storage_key": "property/6767906449166310/019d0266-043d-7633-83eb-5b52d1cd9165.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.dccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=184856283420652342&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "delaware-county-community-college",
      "poi_latitude": "39.9672622",
      "poi_longitude": "-75.3921891",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 610-359-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1a4c-738c-83fb-c51a133ec465",
        "storage_key": "property/6767906449166310/019d0266-1a4c-738c-83fb-c51a133ec465.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD8I_LcjrxokRNnPJc8-9kAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_3dfc34bd-1e83-41c2-bed3-caa599275402",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Delaware County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "201 W Front St, Media, PA 19063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-097a-700a-a29f-f33c20bf8c86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-097a-700a-a29f-f33c20bf8c86",
        "storage_key": "property/6767906449166310/019d0266-097a-700a-a29f-f33c20bf8c86.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9401862939057101931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "delaware-county-courthouse",
      "poi_latitude": "39.9196579",
      "poi_longitude": "-75.3916086",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 610-891-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-2395-76df-95ea-667be39effd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2395-76df-95ea-667be39effd0",
        "storage_key": "property/6767906449166310/019d0266-2395-76df-95ea-667be39effd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qq-QjpxokRa5xopYcgeoI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "custom_306e40be-7afe-40f3-a4e7-05990f896312",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Wawa Corporate Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "260 W Baltimore Pike, Media, PA 19063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-0804-71df-a960-62deb63d3c15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-0804-71df-a960-62deb63d3c15",
        "storage_key": "property/6767906449166310/019d0266-0804-71df-a960-62deb63d3c15.webp",
        "width": 1280,
        "height": 984
      },
      "poi_business_url": "https://www.wawa.com/contact",
      "poi_directions_map_url": "https://maps.google.com/?cid=12038900367231795194&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wawa-corporate-headquarters",
      "poi_latitude": "39.898153",
      "poi_longitude": "-75.4671262",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-444-9292",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-19f2-718d-b2a0-91954f5ebbc5",
        "storage_key": "property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-26xWQ3vxokR-r8rYxnEEqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_21b5befb-ce41-4550-826a-e776721fd82e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Boeing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 S Stewart Ave, Ridley Park, PA 19078, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-0bca-73ef-a4c3-546d38c45776.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-0bca-73ef-a4c3-546d38c45776",
        "storage_key": "property/6767906449166310/019d0266-0bca-73ef-a4c3-546d38c45776.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.boeing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17754567434576268140&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boeing",
      "poi_latitude": "39.8655765",
      "poi_longitude": "-75.3202467",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 610-591-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-19f2-718d-b2a0-91954f5ebbc5",
        "storage_key": "property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeRqPkLvCxokRbAujlgPlZPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_18080e97-05b4-4a55-a117-5f9d45cc4eda",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Eddystone OCC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Eddystone, PA 19022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-0c3e-74ff-981b-5b6382045993.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-0c3e-74ff-981b-5b6382045993",
        "storage_key": "property/6767906449166310/019d0266-0c3e-74ff-981b-5b6382045993.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2025885854839711651&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eddystone-occ",
      "poi_latitude": "39.85877600000001",
      "poi_longitude": "-75.3259353",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-19f2-718d-b2a0-91954f5ebbc5",
        "storage_key": "property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU_4wRbPCxokRo6c1jXNkHRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a2240bb9-5652-449e-bab1-8f8b53c85cb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "poi_name": "Fair Acres Geriatric Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "340 Middletown Rd, Media, PA 19063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-0feb-776a-accb-b136f867d3a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-0feb-776a-accb-b136f867d3a5",
        "storage_key": "property/6767906449166310/019d0266-0feb-776a-accb-b136f867d3a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.fairacres.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2942418276631221505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fair-acres-geriatric-center",
      "poi_latitude": "39.9183213",
      "poi_longitude": "-75.4430824",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 610-891-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-19f2-718d-b2a0-91954f5ebbc5",
        "storage_key": "property/6767906449166310/019d0266-19f2-718d-b2a0-91954f5ebbc5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiV3BWlHqxokRAZU4P9WR1Sg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    }
  ],
  "office_hours": [
    {
      "id": "ec_1efa3cffa1c6877fe25222ee",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_5463c7c3053a9c747327fdb3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_6a65712466cd261025a478ea",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_e1f9925b849906d953e4faf3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_6d8f0a5037fd86cacbd560a4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_0d44ffaa-26a0-4fbe-83aa-6c636011666a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "rating": "5.0",
      "name": "Melissa Conklin",
      "text": "A great, quiet place to live. A lot of stores and shops close by. Love love love my apartment and the amenities on the property. Sara in the office is AMAZING!",
      "date": "2025-08-12",
      "title": ""
    },
    {
      "id": "custom_0fe7033d-e8f3-47cd-8bc6-dea28df6f5aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "rating": "5.0",
      "name": "Maureen",
      "text": "I lived here for 8 years, Good Place, reasonable Rent so far. Although the WINDOWS ARE probably as OLD as the BUILDING!!!! I'm satisfied 😁. And the manager Sarah is GREAT 👍 BUT REALLY NEED SOME NEW WINDOWS 🪟. THANKS ASTON POINT",
      "date": "2025-02-07",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_23ac8e0f-2820-46f0-a128-1b67d74bcbfb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/019d0264-a350-77fb-885e-7d82c0ff9aee.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern living room with dark gray sofa and armchair, light wood coffee table, and abstract art.",
        "public_id": "019d0264-a350-77fb-885e-7d82c0ff9aee",
        "storage_key": "property/6767906449166310/019d0264-a350-77fb-885e-7d82c0ff9aee.webp",
        "width": 3072,
        "height": 2048
      },
      "virtual_tour_title": "1BR, 1BA - 750 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?model=7X7DLCbjeAB"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199ee32-c629-7135-b785-b9d277a91ccd",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-aston-pointe-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310"
    },
    {
      "lead_collector_id": "019c3043-31da-7414-94a5-7404404bde8d",
      "lead_source": "FACEBOOK_ADS",
      "name": "aston-pointe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310"
    },
    {
      "lead_collector_id": "019c3043-324c-71bc-9a8f-7ebe7c4d0838",
      "lead_source": "LANDING_PAGE",
      "name": "aston-pointe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-village-green-pa-499",
      "search_query": "pet friendly apartments Village Green PA",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Village Green, PA",
      "h2_subtitle": "Discover pet-friendly living at Aston Pointe Apartments. Enjoy spacious layouts and amenities perfect for you and your furry friends.",
      "page_copy": "Step into the inviting world of Aston Pointe Apartments where pets are warmly welcomed. Nestled in the heart of Village Green, PA, our community combines cozy charm with modern amenities. Our one- and two-bedroom layouts are crafted with both you and your pets in mind, offering plenty of room for comfort and play.\n\nAston Pointe features a dedicated dog park where your four-legged companions can frolic freely, alongside a host of other amenities that promise ease and enjoyment. With quick access to I-95 and downtown Wilmington, commuting is a breeze. Embrace pet-friendly living today by scheduling a tour of Aston Pointe Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Village Green",
      "seo_description": "Discover pet friendly apartments in Village Green, PA. Visit Aston Pointe Apartments for comfortable living with modern amenities and spacious layouts.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "apartments-dog-park-delaware-county-454",
      "search_query": "apartments with dog park Delaware County",
      "category": "Amenity",
      "h1_title": "Apartments with Dog Park in Delaware County",
      "h2_subtitle": "Explore Aston Pointe Apartments, featuring a dedicated dog park. Perfect for pet lovers in Delaware County seeking a vibrant home community.",
      "page_copy": "At Aston Pointe Apartments in Delaware County, we understand that your pets are family, too. That's why we've designed a community that caters to both you and your furry friends. Among our many amenities is a dedicated dog park, perfect for your pets to enjoy while you connect with fellow pet owners.\n\nLocated in picturesque Village Green, PA, our apartment homes offer renovated kitchens, spacious floor plans, and a professional on-site management team dedicated to your comfort. With easy access to I-95 and the thriving city of Wilmington, Aston Pointe Apartments make it convenient to reach work while enjoying a pet-friendly lifestyle at home. Visit us today and experience life with a dog park at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Delaware County Apartments with Dog Park",
      "seo_description": "Find Delaware County apartments with a dog park at Aston Pointe. Enjoy pet-friendly living in a vibrant community with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "off-street-parking-apartments-near-i-95-60",
      "search_query": "off street parking apartments near I-95",
      "category": "Amenity",
      "h1_title": "Apartments with Off-Street Parking Near I-95",
      "h2_subtitle": "Enjoy the convenience of off-street parking at Aston Pointe Apartments. Located near I-95, our community offers easy access and peace of mind.",
      "page_copy": "Aston Pointe Apartments, located in the charming area of Village Green, PA, provides the perfect combination of convenience and comfort. Our community features off-street parking, ensuring that your vehicle is both accessible and secure. With proximity to I-95, commuting from Aston Pointe is a breeze, taking the stress out of your daily travels.\n\nHere, residents enjoy more than just easy parking. With modern, spacious one- and two-bedroom homes, renovated kitchens, and a park-like setting, Aston Pointe delivers an exceptional living experience. Whether you're headed to downtown Wilmington or exploring the local surroundings, our apartments offer the ideal base with all the amenities you need right at home. Schedule a tour today and discover more about our vibrant community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Off-Street Parking Near I-95",
      "seo_description": "Discover off-street parking apartments near I-95 at Aston Pointe. Enjoy convenient access and modern amenities in Village Green, PA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-19014-54",
      "search_query": "air conditioned apartments in 19014",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in 19014",
      "h2_subtitle": "Stay cool at Aston Pointe Apartments, offering air-conditioned living spaces. Ideal for comfortable living in the 19014 area.",
      "page_copy": "Experience the comfort of air-conditioned living at Aston Pointe Apartments, located in the scenic Village Green area with the zip code 19014. Our spacious one- and two-bedroom apartments are designed to provide maximum comfort, complete with air conditioning to keep you cool and relaxed throughout the year.\n\nBeyond climate comfort, residents at Aston Pointe enjoy a range of modern amenities such as renovated kitchens and a charming park-like setting. Conveniently positioned near major routes like I-95, and within easy reach of downtown Wilmington, our community ensures both a pleasant living environment and accessibility. Visit Aston Pointe Apartments and discover a sanctuary of air-conditioned comfort in 19014.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in 19014",
      "seo_description": "Find air-conditioned apartments in 19014 at Aston Pointe. Enjoy modern amenities and comfort in our spacious, well-equipped living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "apartments-playground-near-downtown-wilmington-992",
      "search_query": "apartments with playground near downtown Wilmington",
      "category": "Amenity",
      "h1_title": "Apartments with Playground Near Wilmington",
      "h2_subtitle": "Discover Aston Pointe Apartments featuring a playground, just a short drive from downtown Wilmington. Perfect for families and outdoor enthusiasts.",
      "page_copy": "Aston Pointe Apartments, nestled in the serene Village Green area, offers the perfect setting for families looking for recreational amenities and easy city access. Our community features a dedicated playground, making it an ideal choice for those with children or anyone who enjoys outdoor living. The playground is a key highlight, providing a safe and fun environment for kids to play and socialize.\n\nLocated conveniently near I-95, residents benefit from quick commutes to downtown Wilmington, blending the charm of suburban living with the convenience of urban access. In addition to the playground, Aston Pointe Apartments offers expansive floor plans, renovated kitchens, and a pet-friendly atmosphere, providing a comprehensive living experience. Make the move today and see what makes our community a cherished home near downtown Wilmington.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Playground Near Downtown Wilmington",
      "seo_description": "Find apartments with a playground near downtown Wilmington at Aston Pointe. Ideal for families, offering modern amenities and easy city access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-village-green-pa-399",
      "search_query": "one bedroom apartments Village Green PA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Village Green, PA",
      "h2_subtitle": "Explore one-bedroom apartments at Aston Pointe in Village Green, PA. Modern amenities and a charming community await you.",
      "page_copy": "Discover the ideal one-bedroom apartment at Aston Pointe Apartments in Village Green, PA. Designed with your comfort in mind, our apartments offer spacious living areas with modern touches, including renovated kitchens that cater to today's discerning renters. The peace of living in a park-like environment coupled with modern conveniences makes our community stand out.\n\nSituated in Delaware County, Aston Pointe provides easy access to I-95, making commutes to nearby Wilmington quick and straightforward. Our professional on-site management team ensures that living here is hassle-free. Whether you're enjoying the on-site dog park or exploring the local area, you'll find that our one-bedroom homes fit every lifestyle need. Schedule a visit to Aston Pointe Apartments in Village Green, PA, and see what makes our community special.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apts Village Green, PA",
      "seo_description": "Discover one-bedroom apartments in Village Green, PA at Aston Pointe. Enjoy modern amenities in a charming community—perfect for your next home.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-delaware-county-643",
      "search_query": "two bedroom apartments Delaware County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Delaware County",
      "h2_subtitle": "Discover spacious two-bedroom apartments at Aston Pointe in Delaware County. Enjoy modern living with convenient access to local amenities.",
      "page_copy": "Aston Pointe Apartments in Delaware County offers spacious two-bedroom units, perfect for families or roommates seeking room to grow. These apartments feature thoughtfully designed layouts with renovated kitchens, accommodating a range of lifestyles. Residents are welcomed by the serene park-like setting, providing a peaceful backdrop for daily living.\n\nOur location in Village Green is advantageous, providing easy access to both local attractions and major thoroughfares like I-95, ensuring hassle-free commutes to Wilmington and beyond. With amenities like a dog park and professional on-site management, Aston Pointe fosters a sense of community and convenience. Experience the blend of comfort and accessibility at our two-bedroom apartments in Delaware County today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apts Delaware County",
      "seo_description": "Find two-bedroom apartments in Delaware County at Aston Pointe. Enjoy spacious living with modern amenities and convenient access to local features.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "apartments-near-pennell-elementary-village-green-671",
      "search_query": "apartments near Pennell Elementary School Village Green",
      "category": "School",
      "h1_title": "Apartments Near Pennell Elementary School",
      "h2_subtitle": "Find your new home near Pennell Elementary School at Aston Pointe in Village Green. Family-friendly living at its best.",
      "page_copy": "Aston Pointe Apartments offers family-friendly living within close proximity to Pennell Elementary School in Village Green, PA. Our community is perfect for families searching for spacious living options that provide comfort and convenience. The charming park-like setting and nearby schools make Aston Pointe an ideal choice for families prioritizing education and quality of life.\n\nIn addition to being near Pennell Elementary School, our residents enjoy a host of amenities, including renovated kitchens, a playground, and a dog park. The convenient access to I-95 allows for effortless commutes to Wilmington and surrounding areas, making daily routines easier. Discover why families love calling Aston Pointe Apartments their home, balancing educational proximity with a supportive residential environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Pennell Elementary, Village Green",
      "seo_description": "Discover apartments near Pennell Elementary in Village Green at Aston Pointe. Family-friendly living with convenient school access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "aston-elementary-nearby-apartments-pa-83",
      "search_query": "Aston Elementary School nearby apartments in PA",
      "category": "School",
      "h1_title": "Aston Elementary Nearby Apartments in PA",
      "h2_subtitle": "Explore comfortable living near Aston Elementary School in PA. Discover what Aston Pointe Apartments offers for convenient family living.",
      "page_copy": "Located in Village Green, Aston Pointe Apartments is the perfect home for families seeking proximity to Aston Elementary School in PA. Our spacious one- and two-bedroom apartments cater to diverse needs, with modern features ensuring a comfortable lifestyle. The park-like setting and convenient amenities provide an ideal environment for raising a family.\n\nAston Pointe combines accessibility with a tranquil atmosphere. With quick access to I-95, commuting to Wilmington and other areas is efficient, while the on-site amenities, including a dog park and playground, offer relaxation and enjoyment close to home. Families appreciate the community feel and educational opportunities within reach. Consider making Aston Pointe your new home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Aston Elementary Nearby Apts PA",
      "seo_description": "Find apartments near Aston Elementary in PA at Aston Pointe. Enjoy family-friendly living with modern amenities and educational opportunities nearby.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "northley-middle-school-close-by-apartments-441",
      "search_query": "Northley Middle School close by apartments",
      "category": "School",
      "h1_title": "Northley Middle School Close By Apartments",
      "h2_subtitle": "Discover the convenience of living close to Northley Middle School at Aston Pointe Apartments. Ideal for families seeking excellent educational access.",
      "page_copy": "For families prioritizing education, Aston Pointe Apartments provides an ideal living situation close to Northley Middle School. Our community offers spacious layouts with modern amenities, perfect for accommodating families desiring both comfort and convenience. With a backdrop of a serene park-like setting, residents enjoy a peaceful lifestyle that boosts family activities.\n\nAston Pointe is strategically situated, allowing easy access not only to Northley Middle School but also to I-95 for hassle-free commuting to Wilmington and other vibrant locales. On-site amenities, such as a dog park and laundry facilities, make daily life easier while fostering a strong sense of community. Embrace the blend of educational proximity and supportive residential features at Aston Pointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Northley Middle School",
      "seo_description": "Explore apartments close to Northley Middle School at Aston Pointe, combining modern living with excellent school access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "sun-valley-high-school-nearby-apartments-19014-481",
      "search_query": "Sun Valley High School nearby apartments 19014",
      "category": "School",
      "h1_title": "Sun Valley High School Nearby Apartments",
      "h2_subtitle": "Explore apartments near Sun Valley High School in the 19014 area. Enjoy the perfect blend of education and modern living at Aston Pointe.",
      "page_copy": "Aston Pointe Apartments offers an exceptional living experience for families seeking homes near Sun Valley High School in the 19014 area. Our spacious apartments are designed to provide comfort and convenience, featuring modern amenities and a welcoming community vibe. Located in Village Green, PA, Aston Pointe ensures easy access to quality education for growing families.\n\nResidents enjoy convenient connections to both educational institutions and transportation routes, like I-95, simplifying travel to Wilmington and beyond. Community amenities, including a dog park and professional on-site management, enhance the living experience, creating a supportive environment. Discover why Aston Pointe is the preferred choice for those valuing education and community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Sun Valley High School 19014",
      "seo_description": "Find nearby apartments to Sun Valley High School in 19014 at Aston Pointe. Perfect for families seeking modern amenities and educational accessibility.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "delaware-county-tech-high-school-neighboring-apartments-67",
      "search_query": "Delaware County Tech High School neighboring apartments",
      "category": "School",
      "h1_title": "Delaware County Tech High School Apartments",
      "h2_subtitle": "Discover apartments neighboring Delaware County Tech High School. Aston Pointe offers modern living with educational opportunities in reach.",
      "page_copy": "Aston Pointe Apartments presents an ideal residential option for those desiring proximity to Delaware County Tech High School. Located in the heart of Village Green, our community supports students' educational pursuits with convenient access to this prestigious institution. Families can choose from spacious one- and two-bedroom apartment homes complete with contemporary features to suit modern living.\n\nThe strategic location of Aston Pointe not only provides easy access to local education but also to major routes like I-95, facilitating straightforward commutes to nearby urban centers such as Wilmington. Enjoy a blend of serene surroundings and practical amenities, including a dog park and off-street parking, making daily life easier while fostering a sense of neighborhood camaraderie.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Delaware County Tech High School",
      "seo_description": "Explore neighboring apartments to Delaware County Tech High School at Aston Pointe. Ideal for families prioritizing modern living and educational access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "neumann-university-nearby-student-apartments-303",
      "search_query": "Neumann University nearby student apartments",
      "category": "School",
      "h1_title": "Neumann University Student Apartments Nearby",
      "h2_subtitle": "Find perfect student apartments near Neumann University at Aston Pointe. Ideal for scholars seeking convenient, modern living in a supportive community.",
      "page_copy": "Aston Pointe Apartments offers an exceptional living experience for students attending Neumann University. Our spacious and modern apartment layouts cater to the needs of students, making it an ideal home base just a short drive from campus. Enjoy the convenience of quick access to academic facilities while residing in a comfortable and stylish environment.\n\nLocated in Village Green, Aston Pointe is strategically positioned for both education and recreation. Students benefit from our community's amenities such as on-site laundry and off-street parking, providing hassle-free living. With access to vital routes like I-95, commuting to class or exploring nearby Wilmington's vibrant scene is effortless. Experience the perfect balance of academic success and contemporary living at Aston Pointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Student Apts Near Neumann University",
      "seo_description": "Discover student apartments near Neumann University at Aston Pointe. Ideal for those seeking convenient living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "holy-family-regional-catholic-school-apartment-proximity-174",
      "search_query": "Holy Family Regional Catholic School apartment proximity",
      "category": "School",
      "h1_title": "Apartments Near Holy Family Regional School",
      "h2_subtitle": "Discover convenient apartment living near Holy Family Regional Catholic School. Aston Pointe offers the ideal environment for families in search of quality education.",
      "page_copy": "Aston Pointe Apartments provides the perfect living environment for families prioritizing education, being conveniently located near Holy Family Regional Catholic School. Our community offers spacious and contemporary one- and two-bedroom options, designed to meet the needs of families who value both education and modern amenities.\n\nSituated in Village Green, PA, Aston Pointe combines peaceful living with an educational advantage. With amenities like a playground, dog park, and professional management, residents experience a comfortable living style. Proximity to I-95 ensures quick access to Wilmington and beyond, making daily commutes and family outings seamless. Embrace the balance of an enriching educational environment alongside modern living conveniences at Aston Pointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Holy Family Regional Catholic School",
      "seo_description": "Find ideal apartments near Holy Family Regional Catholic School at Aston Pointe, perfect for families valuing education and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "apartments-near-media-childrens-house-montessori-school-509",
      "search_query": "apartments near Media Children's House Montessori School",
      "category": "School",
      "h1_title": "Apartments by Media Children's House Montessori",
      "h2_subtitle": "Explore nearby apartments to Media Children's House Montessori School at Aston Pointe. Perfect for families seeking proximity to progressive education.",
      "page_copy": "Aston Pointe Apartments is your ideal choice for living close to Media Children's House Montessori School. Situated in the serene setting of Village Green, our community offers spacious one- and two-bedroom layouts that perfectly cater to the needs of families who appreciate the Montessori method of education.\n\nEnhance your family's lifestyle with modern amenities and a welcoming atmosphere, including a playground and off-street parking. Conveniently located near I-95, residents enjoy effortless access to Wilmington’s vibrant city life as well as daily trips to school. Aston Pointe Apartments provides the perfect blend of comfort and educational convenience, making it an easy choice for families who place a high value on school proximity.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apts to Media Children’s Montessori",
      "seo_description": "Explore Aston Pointe Apartments near Media Children's House Montessori School, ideal for families wanting a blend of convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "coebourn-elementary-vicinity-apartments-delaware-county-765",
      "search_query": "Coebourn Elementary School vicinity apartments in Delaware County",
      "category": "School",
      "h1_title": "Apts Near Coebourn Elementary in Delaware County",
      "h2_subtitle": "Discover apartments near Coebourn Elementary School in Delaware County. Aston Pointe offers family-friendly living in a supportive community.",
      "page_copy": "Located in the picturesque Village Green, Aston Pointe Apartments offers families a perfect home base near Coebourn Elementary School. Our spacious one- and two-bedroom apartments are designed with families in mind, providing comfortable and modern living environments just a short distance from one of Delaware County's highly regarded schools.\n\nFamilies will appreciate the vibrant community setting, complete with a playground and a dog park, ensuring both kids and pets have ample space to play. With easy access to I-95, commuting is a breeze, whether you're heading to school or exploring nearby Wilmington. Choose Aston Pointe for a balanced lifestyle, blending educational proximity with modern conveniences in Delaware County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Coebourn Elementary School",
      "seo_description": "Find apartments near Coebourn Elementary School at Aston Pointe, perfect for families seeking convenient and comfortable living in Delaware County.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "apartments-near-riddle-hospital-pennsylvania-248",
      "search_query": "apartments near Riddle Hospital Pennsylvania",
      "category": "Hospital",
      "h1_title": "Apts Near Riddle Hospital, Pennsylvania",
      "h2_subtitle": "Discover comfort and convenience at Aston Pointe, located near Riddle Hospital in Pennsylvania. Ideal for healthcare professionals and families alike.",
      "page_copy": "Aston Pointe Apartments is the ideal residence for those seeking proximity to Riddle Hospital in Pennsylvania. Nestled in the tranquil Village Green area, our community offers spacious one- and two-bedroom apartments, making it the perfect choice for healthcare professionals and their families.\n\nOur location blends serene living with easy access to Riddle Hospital and other local amenities. Residents enjoy modern features such as renovated kitchens, a playground, and a dog park. Quick access to I-95 ensures effortless commutes to Wilmington and surrounding areas. Aston Pointe offers a blend of convenience, comfort, and a supportive community, ideal for those working at, or frequently visiting, Riddle Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts by Riddle Hospital, Pennsylvania",
      "seo_description": "Explore Aston Pointe Apartments near Riddle Hospital, PA, ideal for healthcare workers and families seeking comfort and convenience close to work.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "apartments-near-weir-park-village-green-952",
      "search_query": "apartments near Weir Park Village Green",
      "category": "Park",
      "h1_title": "Apts Near Weir Park, Village Green",
      "h2_subtitle": "Live close to Weir Park at Aston Pointe in Village Green. Enjoy park-side living with modern amenities in a community-friendly environment.",
      "page_copy": "Aston Pointe Apartments offers the perfect setting for those seeking a home near Weir Park in Village Green. Our spacious one- and two-bedroom floor plans are ideal for individuals and families who appreciate nature’s proximity combined with modern conveniences.\n\nEnjoy the benefits of living just a stroll away from the green spaces of Weir Park, where leisurely walks and outdoor activities await. Our community provides additional amenities like a dog park, playground, and professional on-site management. Convenient access to I-95 also ensures that commuting to downtown Wilmington and beyond is effortless. Choose Aston Pointe for a dynamic blend of park-side living and contemporary features in Village Green.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Weir Park, Village Green",
      "seo_description": "Find Aston Pointe Apartments near Weir Park in Village Green, offering a perfect blend of natural surroundings and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "apartment-rentals-near-chester-creek-trail-pa-447",
      "search_query": "apartment rentals close to Chester Creek Trail PA",
      "category": "Park",
      "h1_title": "Apt Rentals Near Chester Creek Trail, PA",
      "h2_subtitle": "Enjoy outdoor activities with apartment rentals close to Chester Creek Trail in PA. Discover Aston Pointe's spacious living options nearby.",
      "page_copy": "For those who cherish outdoor adventures, Aston Pointe Apartments is an excellent choice, located near the scenic Chester Creek Trail in Pennsylvania. Our well-appointed one- and two-bedroom apartments offer the convenience of being close to this renowned trail, making it easy to enjoy hiking, biking, or peaceful nature walks whenever you desire.\n\nAston Pointe not only provides access to the natural beauty of Chester Creek Trail but also features community amenities such as on-site laundry, a dog park, and off-street parking. With quick access to major routes like I-95, residents can experience the charm of Village Green while remaining connected to the broader Delaware County area. Come home to Aston Pointe, where nature and urban convenience meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Rentals by Chester Creek Trail, PA",
      "seo_description": "Explore Aston Pointe's rentals close to Chester Creek Trail, PA, and enjoy spacious living with access to outdoor activities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "delaware-county-living-near-ridley-creek-state-park-274",
      "search_query": "Delaware County living by Ridley Creek State Park",
      "category": "Park",
      "h1_title": "Delaware County Living Near Ridley Creek Park",
      "h2_subtitle": "Experience the best of Delaware County living near Ridley Creek State Park. Aston Pointe offers comfort and convenience in a picturesque setting.",
      "page_copy": "Aston Pointe Apartments embodies the essence of Delaware County living with its proximity to the beautiful Ridley Creek State Park. Perfect for nature enthusiasts, our community offers the luxury of easy access to the park's sprawling trails and serene landscapes, ideal for weekend hikes or family picnics.\n\nOur spacious one- and two-bedroom apartments in Village Green are designed with modern amenities, including renovated kitchens and pet-friendly spaces, to ensure a comfortable lifestyle. The community also boasts amenities like a playground and on-site laundry facilities. Residents can quickly access essential routes such as I-95, making commuting a breeze. Discover a harmonious blend of natural beauty and urban convenience at Aston Pointe Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Delaware County Living Near Ridley Creek Park",
      "seo_description": "Discover Delaware County living at Aston Pointe, near Ridley Creek State Park. Enjoy modern living with nature at your doorstep.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "tyler-arboretum-nearby-apartments-19014-511",
      "search_query": "Tyler Arboretum nearby apartments 19014",
      "category": "Park",
      "h1_title": "Apartments Near Tyler Arboretum 19014",
      "h2_subtitle": "Discover comfortable living with nearby apartments close to Tyler Arboretum in the 19014 area. Aston Pointe offers modern amenities and scenic surroundings.",
      "page_copy": "Nestled in the heart of Village Green, Aston Pointe Apartments provides a tranquil living experience near Tyler Arboretum in the 19014 zip code. Our community offers a selection of spacious one- and two-bedroom floor plans, perfect for those who appreciate natural beauty and serene surroundings.\n\nLiving at Aston Pointe means enjoying the convenience of quick access to Tyler Arboretum's lush gardens, walking trails, and family-friendly events. With amenities such as a dog park, off-street parking, and professional on-site management, residents experience a harmonious balance of leisure and lifestyle. Plus, the proximity to major routes like I-95 ensures that you're well connected to the wider region. Choose Aston Pointe Apartments for an ideal blend of nature and contemporary living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tyler Arboretum 19014",
      "seo_description": "Live at Aston Pointe, near Tyler Arboretum in 19014. Enjoy modern amenities and easy access to natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "lewis-h-fisher-memorial-park-area-apartments-721",
      "search_query": "Lewis H Fisher Memorial Park area apartments",
      "category": "Park",
      "h1_title": "Apts Near Lewis H Fisher Memorial Park",
      "h2_subtitle": "Find apartments in the Lewis H Fisher Memorial Park area. Aston Pointe offers excellent living options near this community park.",
      "page_copy": "Discover the perfect place to call home with Aston Pointe Apartments, located near Lewis H Fisher Memorial Park. Our community in Village Green provides a picturesque setting and excellent access to neighborhood amenities and local attractions.\n\nAston Pointe offers modern one- and two-bedroom apartments with features like renovated kitchens and pet-friendly policies. Enjoy a park-like environment within our grounds, complemented by on-site conveniences such as laundry facilities and a dog park. With easy accessibility to major routes like I-95 and the vibrant city life of downtown Wilmington, you'll find everything you need right here in Delaware County. Experience the charm and convenience of living near Lewis H Fisher Memorial Park at Aston Pointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lewis H Fisher Memorial Park",
      "seo_description": "Aston Pointe offers apartments near Lewis H Fisher Memorial Park with modern amenities and excellent location in Delaware County.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "apartments-village-green-concord-square-park-378",
      "search_query": "apartments in Village Green near Concord Square Park",
      "category": "Park",
      "h1_title": "Village Green Apartments Near Concord Square",
      "h2_subtitle": "Explore modern living in Village Green near Concord Square Park. Aston Pointe Apartments offer comfort and convenience with top-notch amenities.",
      "page_copy": "Aston Pointe Apartments offer a charming and contemporary living experience in Village Green, conveniently located near Concord Square Park. Our community presents residents with spacious one- and two-bedroom floor plans that are thoughtfully designed to enhance your lifestyle with modern amenities.\n\nEnjoy living in a serene, park-like environment with easy access to Concord Square Park's playground and green spaces. Our extensive amenity list includes renovated kitchens, pet-friendly areas, and off-street parking. The professional on-site management team ensures a seamless living experience. Plus, the proximity to major highways like I-95 facilitates quick commutes, connecting you to the broader Delaware County area and beyond. Choose Aston Pointe Apartments for the ultimate Village Green experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Village Green Apartments Near Concord Sq Park",
      "seo_description": "Live in Village Green near Concord Square Park. Aston Pointe offers modern amenities and a convenient location for dynamic lifestyles.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166310",
      "source": "custom",
      "page_item_url": "bridgewater-farms-park-accessible-apartments-777",
      "search_query": "Bridgewater Farms Park accessible apartments",
      "category": "Park",
      "h1_title": "Accessible Apartments Near Bridgewater Farms",
      "h2_subtitle": "Discover accessible apartments near Bridgewater Farms Park. Aston Pointe offers inclusivity and comfort in a picturesque setting.",
      "page_copy": "Find the perfect blend of accessibility and comfort at Aston Pointe Apartments, located near Bridgewater Farms Park in Village Green. Our community features spacious, accessible one- and two-bedroom floor plans designed with modern amenities and inclusivity in mind.\n\nA short distance from Bridgewater Farms Park, residents have easy access to beautiful green spaces and recreational activities. Aston Pointe offers a range of desirable features such as on-site laundry facilities, a dog park, and off-street parking, all managed by our professional on-site team. With quick connectivity to I-95, residents enjoy seamless access to the broader region, making Aston Pointe the ideal choice for those seeking convenience and comfort near Bridgewater Farms Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
      "featured_image_media": {
        "alt_text": "Exterior of brick apartment buildings with green lawns and sidewalks.",
        "public_id": "01a015d9-36ee-74a5-ad11-5aef3c48cf1b",
        "storage_key": "property/6767906449166310/01a015d9-36ee-74a5-ad11-5aef3c48cf1b.webp",
        "width": 1000,
        "height": 667
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Accessible Apartments Near Bridgewater Farms",
      "seo_description": "Live near Bridgewater Farms Park at Aston Pointe, offering accessible living with modern amenities in a serene setting.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5048"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976233451"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4993350"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MQD62QQB"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://liveastonpointe.fatwin.com/api/websites/resources/1?x=MkR4ZXo0NGJ6TDA4d3FTMUxSeUlCaWFnMngxQWYvRnN0YnpxcGt2SWV0am8vM21BcjZiMWdGcldCVUFqOHY3MXRraFduQTlCbHh3OTh6L1hnR3JJWUE9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "95499084-43e6-11ef-8606-57a223a2bbe3"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95499084-43e6-11ef-8606-57a223a2bbe3/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95499084-43e6-11ef-8606-57a223a2bbe3/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlZiNnlqZzNRUE94dFpHSTJrUWQ2dlE9PSIsInZhbHVlIjoiTFNCbkdXRThWQXNKU0dPb2NkMzVzQT09IiwibWFjIjoiYTY2NzU0NWU4MGI1NjI0NDc4ZjNjZDhlODFjNWY4ZjBiMTk1MWQ4MGVlOGVlYjgzYTVmOWJiNjI2ZGZlNDhjYSJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5048",
  "custom_repli_id": "9976233451",
  "custom_realpage_id": "4993350",
  "custom_google_gtm_id": "GTM-MQD62QQB",
  "custom_perq_script_url": "https://liveastonpointe.fatwin.com/api/websites/resources/1?x=MkR4ZXo0NGJ6TDA4d3FTMUxSeUlCaWFnMngxQWYvRnN0YnpxcGt2SWV0am8vM21BcjZiMWdGcldCVUFqOHY3MXRraFduQTlCbHh3OTh6L1hnR3JJWUE9PQ2",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "95499084-43e6-11ef-8606-57a223a2bbe3",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95499084-43e6-11ef-8606-57a223a2bbe3/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95499084-43e6-11ef-8606-57a223a2bbe3/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlZiNnlqZzNRUE94dFpHSTJrUWQ2dlE9PSIsInZhbHVlIjoiTFNCbkdXRThWQXNKU0dPb2NkMzVzQT09IiwibWFjIjoiYTY2NzU0NWU4MGI1NjI0NDc4ZjNjZDhlODFjNWY4ZjBiMTk1MWQ4MGVlOGVlYjgzYTVmOWJiNjI2ZGZlNDhjYSJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "83485b4d-01d6-4e49-a97c-e72fb1f75b8f",
  "custom_audioeye_site_hash": "9a21233601f75794ae84c04b4125e60f"
};

export const generatedAt = '2026-10-22T20:07:48.949Z';
